import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState('home');
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    contact: '',
    itemType: '',
    description: '',
    photoConfirm: false
  });
  const [formStatus, setFormStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [showReplayModal, setShowReplayModal] = useState(false);
  const [selectedReplay, setSelectedReplay] = useState<string>('');
  const [activeGuideTab, setActiveGuideTab] = useState<'shoushan' | 'dzi' | 'buddha'>('shoushan');
  const [activeFaqCategory, setActiveFaqCategory] = useState<'process' | 'payment' | 'shipping' | 'appraisal'>('process');
  const [expandedFaqIndex, setExpandedFaqIndex] = useState<number | null>(null);
  
  // 最新拍品輪播狀態
  const [currentAuctionSlide, setCurrentAuctionSlide] = useState(0);
  
  // 線上預約送拍彈窗狀態
  const [showBookingModal, setShowBookingModal] = useState(false);
  const [bookingFormData, setBookingFormData] = useState({
    name: '',
    contact: '',
    email: '',
    itemType: '',
    appointmentDate: '',
    location: '',
    description: ''
  });
  const [bookingFormStatus, setBookingFormStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  
  // 直播倒數計時
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  // 最新拍品數據
  const upcomingAuctions = [
    {
      name: '清代田黃石雕龍印章',
      category: '壽山石',
      categoryColor: 'bg-amber-500',
      startPrice: 'NT$ 280,000',
      lot: 'LOT 001',
      image: 'https://public.readdy.ai/ai/img_res/77aae88673562525f2cdf9ef1101273d.jpg'
    },
    {
      name: '齊白石花鳥冊頁',
      category: '字畫',
      categoryColor: 'bg-emerald-600',
      startPrice: 'NT$ 520,000',
      lot: 'LOT 002',
      image: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20ink%20painting%20album%20by%20Qi%20Baishi%20featuring%20delicate%20bird%20and%20flower%20motifs%2C%20elegant%20brushwork%20with%20red%20seal%20stamps%2C%20aged%20silk%20mounting%20with%20natural%20patina%2C%20displayed%20on%20neutral%20background%20with%20soft%20scholarly%20lighting%2C%20museum%20quality%20artwork&width=600&height=600&seq=upcoming-qibaishi-flower-001&orientation=squarish'
    },
    {
      name: '冰種翡翠手鐲',
      category: '翡翠',
      categoryColor: 'bg-teal-600',
      startPrice: 'NT$ 380,000',
      lot: 'LOT 003',
      image: 'https://readdy.ai/api/search-image?query=Premium%20ice-type%20jadeite%20bangle%20with%20vibrant%20emerald%20green%20color%20and%20exceptional%20translucency%2C%20displayed%20on%20dark%20velvet%20stand%2C%20professional%20jewelry%20lighting%20highlighting%20the%20natural%20green%20color%20and%20glass-like%20clarity%2C%20no%20cracks%20visible%2C%20prestigious%20jewelry%20presentation&width=600&height=600&seq=upcoming-jade-bangle-001&orientation=squarish'
    },
    {
      name: '西藏九眼天珠',
      category: '天珠',
      categoryColor: 'bg-rose-600',
      startPrice: 'NT$ 450,000',
      lot: 'LOT 004',
      image: 'https://readdy.ai/api/search-image?query=Ancient%20Tibetan%20nine-eye%20Dzi%20bead%20with%20distinctive%20nine%20eye%20patterns%20clearly%20visible%2C%20deep%20brown%20agate%20with%20white%20eye%20markings%20showing%20natural%20weathering%2C%20displayed%20on%20traditional%20Tibetan%20silk%20fabric%2C%20warm%20ambient%20lighting%20emphasizing%20mystical%20quality%2C%20rare%20collectible&width=600&height=600&seq=upcoming-nine-eye-dzi-001&orientation=squarish'
    },
    {
      name: '明代銅鎏金觀音像',
      category: '佛像',
      categoryColor: 'bg-yellow-600',
      startPrice: 'NT$ 680,000',
      lot: 'LOT 005',
      image: 'https://readdy.ai/api/search-image?query=Ming%20dynasty%20gilt%20bronze%20Guanyin%20Bodhisattva%20statue%20with%20serene%20expression%2C%20golden%20surface%20with%20fine%20details%20of%20robes%20and%20jewelry%2C%20displayed%20against%20dark%20background%20with%20dramatic%20lighting%20emphasizing%20the%20golden%20patina%2C%20museum%20quality%20religious%20artifact&width=600&height=600&seq=upcoming-ming-guanyin-001&orientation=squarish'
    },
    {
      name: '芙蓉石雕山水擺件',
      category: '壽山石',
      categoryColor: 'bg-amber-500',
      startPrice: 'NT$ 180,000',
      lot: 'LOT 006',
      image: 'https://readdy.ai/api/search-image?query=Furong%20Shoushan%20stone%20landscape%20carving%20with%20delicate%20pink%20color%2C%20intricate%20mountain%20and%20figure%20scenes%2C%20fine%20craftsmanship%20showing%20traditional%20Chinese%20scenery%2C%20displayed%20on%20dark%20wooden%20stand%20against%20gradient%20background%2C%20professional%20lighting%20highlighting%20pink%20translucency&width=600&height=600&seq=upcoming-furong-landscape-001&orientation=squarish'
    },
    {
      name: '張大千潑彩山水',
      category: '字畫',
      categoryColor: 'bg-emerald-600',
      startPrice: 'NT$ 880,000',
      lot: 'LOT 007',
      image: 'https://readdy.ai/api/search-image?query=Zhang%20Daqian%20splashed-color%20landscape%20painting%20with%20vibrant%20colors%20and%20abstract%20mountain%20scenery%2C%20traditional%20Chinese%20painting%20with%20modern%20artistic%20expression%2C%20red%20seal%20stamps%2C%20displayed%20on%20neutral%20background%20with%20museum%20lighting%2C%20masterpiece%20quality&width=600&height=600&seq=upcoming-zhangdaqian-landscape-001&orientation=squarish'
    },
    {
      name: '和田白玉觀音牌',
      category: '玉器',
      categoryColor: 'bg-slate-500',
      startPrice: 'NT$ 220,000',
      lot: 'LOT 008',
      image: 'https://readdy.ai/api/search-image?query=Premium%20Hetian%20white%20jade%20Guanyin%20pendant%20with%20pure%20white%20color%20and%20fine%20texture%2C%20intricately%20carved%20Bodhisattva%20figure%20with%20serene%20expression%2C%20displayed%20on%20dark%20silk%20fabric%2C%20soft%20lighting%20emphasizing%20the%20jades%20natural%20luster%20and%20translucency%2C%20elegant%20presentation&width=600&height=600&seq=upcoming-hetian-guanyin-001&orientation=squarish'
    }
  ];

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // 倒數計時邏輯
  useEffect(() => {
    // 設定下次直播時間為本週六 20:00
    const getNextSaturday = () => {
      const now = new Date();
      const dayOfWeek = now.getDay();
      const daysUntilSaturday = dayOfWeek === 6 ? 7 : (6 - dayOfWeek + 7) % 7;
      const nextSaturday = new Date(now);
      nextSaturday.setDate(now.getDate() + daysUntilSaturday);
      nextSaturday.setHours(20, 0, 0, 0);
      
      // 如果今天是週六但已過20:00，則設定為下週六
      if (dayOfWeek === 6 && now.getHours() >= 20) {
        nextSaturday.setDate(nextSaturday.getDate() + 7);
      }
      
      return nextSaturday;
    };

    const updateCountdown = () => {
      const targetDate = getNextSaturday();
      const now = new Date();
      const difference = targetDate.getTime() - now.getTime();

      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60)
        });
      }
    };

    updateCountdown();
    const timer = setInterval(updateCountdown, 1000);

    return () => clearInterval(timer);
  }, []);

  // 最新拍品自動輪播
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentAuctionSlide((prev) => (prev + 1) % upcomingAuctions.length);
    }, 4000); // 每4秒自動切換

    return () => clearInterval(timer);
  }, [upcomingAuctions.length]);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setActiveSection(sectionId);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value, type } = e.target;
    if (type === 'checkbox') {
      const checked = (e.target as HTMLInputElement).checked;
      setFormData(prev => ({ ...prev, [name]: checked }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!formData.name || !formData.email || !formData.contact || !formData.itemType || !formData.description) {
      return;
    }

    if (formData.description.length > 500) {
      return;
    }

    setFormStatus('submitting');

    try {
      const formBody = new URLSearchParams({
        name: formData.name,
        email: formData.email,
        contact: formData.contact,
        itemType: formData.itemType,
        description: formData.description,
        photoConfirm: formData.photoConfirm ? '已確認拍攝注意事項' : '未確認'
      });

      const response = await fetch('https://readdy.ai/api/form/d6l5i0o5dsf7sr1n5q10', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formBody.toString()
      });

      if (response.ok) {
        setFormStatus('success');
        setFormData({ name: '', email: '', contact: '', itemType: '', description: '', photoConfirm: false });
        setTimeout(() => setFormStatus('idle'), 6000);
      } else {
        setFormStatus('error');
        setTimeout(() => setFormStatus('idle'), 3000);
      }
    } catch {
      setFormStatus('error');
      setTimeout(() => setFormStatus('idle'), 3000);
    }
  };

  // 線上預約送拍表單處理
  const handleBookingInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setBookingFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleBookingSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!bookingFormData.name || !bookingFormData.contact || !bookingFormData.email || 
        !bookingFormData.itemType || !bookingFormData.appointmentDate || 
        !bookingFormData.location || !bookingFormData.description) {
      return;
    }

    if (bookingFormData.description.length > 300) {
      return;
    }

    setBookingFormStatus('submitting');

    try {
      const formBody = new URLSearchParams({
        name: bookingFormData.name,
        contact: bookingFormData.contact,
        email: bookingFormData.email,
        itemType: bookingFormData.itemType,
        appointmentDate: bookingFormData.appointmentDate,
        location: bookingFormData.location,
        description: bookingFormData.description
      });

      const response = await fetch('https://readdy.ai/api/form/d6ler3h4a3uojp5fgap0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formBody.toString()
      });

      if (response.ok) {
        setBookingFormStatus('success');
        setBookingFormData({ 
          name: '', 
          contact: '', 
          email: '', 
          itemType: '', 
          appointmentDate: '', 
          location: '', 
          description: '' 
        });
        setTimeout(() => {
          setBookingFormStatus('idle');
          setShowBookingModal(false);
        }, 3000);
      } else {
        setBookingFormStatus('error');
        setTimeout(() => setBookingFormStatus('idle'), 3000);
      }
    } catch {
      setBookingFormStatus('error');
      setTimeout(() => setBookingFormStatus('idle'), 3000);
    }
  };

  const handleReplayClick = (title: string) => {
    setSelectedReplay(title);
    setShowReplayModal(true);
  };

  const closeReplayModal = () => {
    setShowReplayModal(false);
    setSelectedReplay('');
  };

  const toggleFaq = (index: number) => {
    setExpandedFaqIndex(expandedFaqIndex === index ? null : index);
  };

  // 輪播控制函數
  const goToAuctionSlide = (index: number) => {
    setCurrentAuctionSlide(index);
  };

  const nextAuctionSlide = () => {
    setCurrentAuctionSlide((prev) => (prev + 1) % upcomingAuctions.length);
  };

  const prevAuctionSlide = () => {
    setCurrentAuctionSlide((prev) => (prev - 1 + upcomingAuctions.length) % upcomingAuctions.length);
  };

  // FAQ 數據
  const faqData = {
    process: [
      {
        question: '收購流程是怎樣的？需要多長時間？',
        answer: '收購流程非常簡單：1) 透過電話、LINE 或微信聯繫我們，並發送藏品照片；2) 林先生將在24小時內進行初步鑑定並給予報價；3) 雙方達成協議後，可選擇親自送件或安排專人上門收購；4) 現場驗貨確認後立即付款。整個流程通常在1-3個工作日內完成。'
      },
      {
        question: '我的藏品需要帶什麼證明文件嗎？',
        answer: '如果您有藏品的購買憑證、鑑定證書、出版著錄或來源證明，請一併提供，這將有助於我們更準確地評估藏品價值。但即使沒有相關文件，林先生憑藉三十年的專業經驗，也能為您的藏品進行專業鑑定。'
      },
      {
        question: '如果鑑定後我不想出售，會收取鑑定費嗎？',
        answer: '完全不會！我們提供的鑑定服務是完全免費的，無論您最終是否決定出售，都不會收取任何鑑定費用。我們希望透過專業的服務建立長期的信任關係，讓每位藏家都能放心諮詢。'
      },
      {
        question: '你們收購哪些類型的藏品？有什麼要求？',
        answer: '我們專注收購四大類別：壽山石（田黃、芙蓉、高山等）、名家字畫、翡翠珠寶與西藏天珠、古董佛像。我們重視藏品的真實性與品質，只收購經過專業鑑定確認為真品的藏品。無論您的藏品大小、新舊，只要是真品，我們都歡迎您聯繫諮詢。'
      }
    ],
    payment: [
      {
        question: '收購款項如何支付？支持哪些付款方式？',
        answer: '我們提供多種安全便捷的付款方式：1) 現金支付（適合小額交易）；2) 銀行轉帳（當日到帳）；3) 支票支付（大額交易）。所有款項均在驗貨確認後立即支付，絕不拖延。我們承諾交易透明，讓您安心放心。'
      },
      {
        question: '收購價格是如何評估的？會不會被壓價？',
        answer: '我們的收購價格基於三個標準：1) 藏品的真實性與品質；2) 當前市場行情與拍賣紀錄；3) 藏品的稀有度與收藏價值。林先生憑藉三十年的行業經驗與誠信經營理念，給出的價格公正合理，絕不惡意壓價。我們相信長期合作比一次性交易更重要。'
      },
      {
        question: '大額交易的安全性如何保障？',
        answer: '對於大額交易（超過百萬元），我們提供以下安全保障：1) 可在銀行或公證處進行交易；2) 提供正式收購合約與收據；3) 支持第三方見證；4) 可分期付款或採用託管方式。我們在業界經營三十年，信譽良好，您可以完全放心。'
      },
      {
        question: '如果對收購價格不滿意，可以議價嗎？',
        answer: '當然可以！我們歡迎藏家提出自己的期望價格，並說明理由。如果您有其他鑑定機構的評估報告或市場參考價格，也請一併提供。我們會根據實際情況進行協商，力求達成雙方都滿意的價格。誠信溝通是我們的經營原則。'
      }
    ],
    shipping: [
      {
        question: '外地藏家如何寄送藏品？運費由誰承擔？',
        answer: '外地藏家可選擇以下方式：1) 使用順豐快遞或郵局保價寄送（建議保價金額為預估價值的80%）；2) 我們可安排專人上門收購（適合高價值藏品，費用由我們承擔）；3) 您也可以親自送件到台北收購地址。一般情況下，寄送運費由藏家承擔，但對於高價值藏品，我們可協商運費分攤。'
      },
      {
        question: '藏品在運送過程中損壞或遺失怎麼辦？',
        answer: '為確保運送安全，我們強烈建議：1) 使用保價寄送服務，並妥善包裝藏品；2) 拍攝藏品寄送前的照片與影片作為證據；3) 保留寄送單據與保價憑證。如果藏品在運送過程中損壞或遺失，可向快遞公司申請理賠。對於高價值藏品，我們建議選擇專人上門收購，避免運送風險。'
      },
      {
        question: '你們會提供專人上門收購服務嗎？',
        answer: '會的！對於價值較高的藏品（通常為50萬元以上），我們可安排林先生或專業團隊親自上門鑑定與收購。服務範圍涵蓋台灣全島及部分海外地區（如香港、澳門、中國大陸主要城市）。上門服務完全免費，所有費用由我們承擔，讓您在家中就能完成交易。'
      }
    ],
    appraisal: [
      {
        question: '免費鑑定服務包含哪些內容？',
        answer: '我們的免費鑑定服務包括：1) 藏品真偽鑑定；2) 年代與產地判斷；3) 品質等級評估；4) 市場價值估算；5) 收藏建議與保養指導。林先生會根據藏品的材質、工藝、紋理、包漿等多方面進行綜合分析，並提供詳細的鑑定報告。整個過程完全免費，無任何隱藏費用。'
      },
      {
        question: '鑑定結果的準確性如何保證？',
        answer: '林先生來自收藏世家，擁有三十年的專業鑑定經驗，曾為數千件藏品提供鑑定服務，準確率極高。我們的鑑定基於：1) 豐富的實戰經驗與眼力；2) 對各類藏品的深入研究；3) 與業界專家的交流學習；4) 參考權威出版物與拍賣紀錄。如有需要，我們也可推薦第三方權威機構進行複檢。'
      },
      {
        question: '鑑定後會提供書面鑑定證書嗎？',
        answer: '對於確定收購的藏品，我們會提供正式的收購合約與收據。如果您需要獨立的鑑定證書（不涉及收購），我們可推薦權威的第三方鑑定機構，但該服務可能需要支付相應的鑑定費用。我們的免費鑑定主要是口頭評估與市場價值分析。'
      },
      {
        question: '如果鑑定為贋品，你們會如何告知？',
        answer: '如果經鑑定確認為贋品或現代仿品，林先生會以專業且尊重的態度告知您，並詳細說明判斷依據（如材質、工藝、紋理、包漿等方面的問題）。我們理解每位藏家對藏品的感情，會盡量提供建設性的建議，幫助您避免未來的收藏風險。我們的目標是建立長期信任，而非一次性交易。'
      }
    ]
  };

  const currentFaqList = faqData[activeFaqCategory];

  return (
    <div className="min-h-screen bg-white">
      {/* 跑馬燈公告 */}
      <div className="sticky top-0 z-50 bg-[#d4af37] text-[#1a3a2e] py-1.5 overflow-hidden">
        <div className="flex items-center">
          <div className="flex-shrink-0 bg-[#1a3a2e] text-[#d4af37] px-3 py-0.5 text-xs font-bold tracking-widest whitespace-nowrap z-10 relative">
            最新公告
          </div>
          <div className="overflow-hidden flex-1 ml-2">
            <div className="flex whitespace-nowrap animate-marquee">
              {[1, 2].map((i) => (
                <span key={i} className="inline-flex items-center gap-4 pr-12 text-xs font-semibold">
                  <span className="flex items-center gap-1.5 whitespace-nowrap">
                    <i className="ri-gift-line"></i>
                    免費鑑價 · 完全免費 · 無需付費
                  </span>
                  <span className="text-[#1a3a2e]/40">✦</span>
                  <span className="flex items-center gap-1.5 whitespace-nowrap">
                    <i className="ri-time-line"></i>
                    24小時內專業回覆 · 三十年鑑定經驗
                  </span>
                  <span className="text-[#1a3a2e]/40">✦</span>
                  <span className="flex items-center gap-1.5 whitespace-nowrap">
                    <i className="ri-phone-line"></i>
                    台灣：0916-661789 ｜ 大陸：150-0500-0353
                  </span>
                  <span className="text-[#1a3a2e]/40">✦</span>
                  <span className="flex items-center gap-1.5 whitespace-nowrap">
                    <i className="ri-auction-line"></i>
                    2025 全球藝術品拍賣會 · 火熱徵集中
                  </span>
                  <span className="text-[#1a3a2e]/40">✦</span>
                  <span className="flex items-center gap-1.5 whitespace-nowrap">
                    <i className="ri-shield-check-line"></i>
                    保真承諾 · 專業鑑定 · 誠信交易
                  </span>
                  <span className="text-[#1a3a2e]/40">✦</span>
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* 导航栏 */}
      <nav className={`sticky top-[34px] left-0 right-0 z-40 transition-all duration-300 ${
        isScrolled ? 'bg-[#1a3a2e] shadow-lg' : 'bg-[#1a3a2e]/90 backdrop-blur-sm'
      }`}>
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-3 md:py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-2">
              <img 
                src="https://static.readdy.ai/image/4f3f06d226654fda02a3ba64a379f0f2/b873450daa58730c2c382d5e572253a8.jpeg" 
                alt="光特" 
                className="h-9 w-9 md:h-12 md:w-12 object-contain rounded-full"
              />
              <span className="text-lg md:text-2xl font-bold text-white">光特</span>
            </div>
            
            <div className="hidden md:flex items-center space-x-8">
              <button onClick={() => scrollToSection('home')} className="text-white hover:text-[#d4af37] transition-colors cursor-pointer whitespace-nowrap">首頁</button>
              <button onClick={() => scrollToSection('live-preview')} className="text-white hover:text-[#d4af37] transition-colors cursor-pointer whitespace-nowrap">直播</button>
              <button onClick={() => scrollToSection('shoushan')} className="text-white hover:text-[#d4af37] transition-colors cursor-pointer whitespace-nowrap">服務項目</button>
              <button onClick={() => scrollToSection('about')} className="text-white hover:text-[#d4af37] transition-colors cursor-pointer whitespace-nowrap">關於我們</button>
            </div>

            <div className="flex items-center gap-2">
              <button
                onClick={() => scrollToSection('collection-2025')}
                className="relative bg-[#d4af37] border-2 border-[#d4af37] text-[#1a3a2e] px-3 md:px-5 py-1.5 md:py-2 rounded-full font-bold hover:bg-[#c19b2e] hover:border-[#c19b2e] transition-all cursor-pointer whitespace-nowrap flex items-center gap-1.5 text-sm md:text-base"
              >
                <span className="relative flex h-2 w-2">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-75"></span>
                  <span className="relative inline-flex rounded-full h-2 w-2 bg-red-600"></span>
                </span>
                2025徵集
              </button>
              <button
                onClick={() => scrollToSection('free-appraisal-form')}
                className="hidden sm:flex bg-white text-[#1a3a2e] px-3 md:px-5 py-1.5 md:py-2 rounded-full font-bold hover:bg-[#d4af37] hover:text-[#1a3a2e] transition-all cursor-pointer whitespace-nowrap items-center gap-1.5 shadow-md border-2 border-white text-sm md:text-base"
              >
                <i className="ri-search-eye-line text-[#d4af37]"></i>
                <span>免費鑑價</span>
                <span className="bg-red-500 text-white text-[9px] px-1.5 py-0.5 rounded-full font-bold leading-none whitespace-nowrap">免費</span>
              </button>
              <a href="tel:0916661789" className="hidden md:block bg-white/20 border border-white/50 text-white px-4 md:px-6 py-1.5 md:py-2 rounded-full font-semibold hover:bg-white/30 transition-colors cursor-pointer whitespace-nowrap text-sm md:text-base">
                立即諮詢
              </a>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero 区域 */}
      <section id="home" className="relative h-screen flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src="https://readdy.ai/api/search-image?query=Exquisite%20Chinese%20Shoushan%20stone%20carving%20with%20intricate%20details%2C%20featuring%20rich%20red%20and%20golden%20amber%20colors%2C%20displayed%20on%20a%20dark%20elegant%20wooden%20stand%20against%20a%20deep%20forest%20green%20gradient%20background%20with%20subtle%20traditional%20Chinese%20cloud%20patterns%2C%20professional%20museum%20lighting%20highlighting%20the%20stones%20natural%20translucency%20and%20carved%20textures%2C%20luxurious%20and%20refined%20atmosphere&width=1920&height=1080&seq=hero-bg-001&orientation=landscape"
            alt="壽山石精品"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>
        </div>

        <div className="relative z-10 text-center px-4 md:px-6 max-w-5xl mx-auto w-full">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-3 md:mb-4 leading-tight">
            大陸一流直播拍賣專家
          </h1>
          <p className="text-base md:text-xl text-white/80 mb-6 md:mb-10">光特藝術拍賣 · 三十年收藏鑒賞 · 壽山石、字畫、珠寶天珠、佛像</p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-6">
            <button
              onClick={() => scrollToSection('free-appraisal-form')}
              className="relative bg-[#d4af37] text-[#1a3a2e] px-7 md:px-10 py-3 md:py-4 rounded-full text-base md:text-lg font-bold hover:bg-[#c19b2e] transition-all hover:scale-105 cursor-pointer whitespace-nowrap flex items-center gap-2 md:gap-3 shadow-2xl"
            >
              <i className="ri-search-eye-line text-lg md:text-xl"></i>
              立即免費鑑價
              <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs px-2 py-0.5 rounded-full font-bold whitespace-nowrap animate-bounce">免費</span>
            </button>
            <button onClick={() => scrollToSection('about')} className="border-2 border-[#d4af37] text-white px-7 md:px-10 py-3 md:py-4 rounded-full text-base md:text-lg font-semibold hover:bg-[#d4af37]/20 transition-all hover:scale-105 cursor-pointer whitespace-nowrap flex items-center gap-2">
              <i className="ri-play-circle-line"></i>
              了解更多
            </button>
          </div>

          {/* Hero 底部信任標籤 */}
          <div className="mt-6 md:mt-10 flex flex-wrap items-center justify-center gap-2 md:gap-3">
            {[
              { icon: 'ri-gift-line', text: '完全免費鑑價' },
              { icon: 'ri-time-line', text: '24小時回覆' },
              { icon: 'ri-shield-check-line', text: '三十年專業' },
              { icon: 'ri-lock-line', text: '資料保密' },
            ].map((item, i) => (
              <div key={i} className="flex items-center gap-1.5 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-3 md:px-4 py-1.5 md:py-2">
                <i className={`${item.icon} text-[#d4af37] text-sm`}></i>
                <span className="text-white text-xs md:text-sm font-medium whitespace-nowrap">{item.text}</span>
              </div>
            ))}

            {/* 分隔線 */}
            <div className="hidden sm:block w-px h-5 bg-white/25 mx-1"></div>

            {/* 社群追蹤 */}
            <a
              href="https://www.instagram.com/twgtart"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1.5 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-3 md:px-4 py-1.5 md:py-2 hover:bg-white/20 transition-colors cursor-pointer"
            >
              <i className="ri-instagram-line text-pink-400 text-sm"></i>
              <span className="text-white text-xs md:text-sm font-medium whitespace-nowrap">IG @twgtart</span>
            </a>
            <a
              href="https://www.facebook.com/p/%E5%85%89%E7%89%B9%E8%97%9D%E8%A1%93%E6%8B%8D%E8%B3%A3-61573967776391/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1.5 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-3 md:px-4 py-1.5 md:py-2 hover:bg-white/20 transition-colors cursor-pointer"
            >
              <i className="ri-facebook-fill text-[#4a9eff] text-sm"></i>
              <span className="text-white text-xs md:text-sm font-medium whitespace-nowrap">FB 粉絲頁</span>
            </a>
            <a
              href="https://www.youtube.com/@光特藝術拍賣"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1.5 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-3 md:px-4 py-1.5 md:py-2 hover:bg-white/20 transition-colors cursor-pointer"
            >
              <i className="ri-youtube-fill text-red-400 text-sm"></i>
              <span className="text-white text-xs md:text-sm font-medium whitespace-nowrap">YouTube</span>
            </a>
          </div>
        </div>
      </section>

      {/* 最新拍品預覽輪播區 */}
      <section className="py-20 bg-gradient-to-br from-[#0d1f17] via-[#1a3a2e] to-[#0d1f17] relative overflow-hidden">
        {/* 裝飾背景 */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-1/4 right-1/4 w-96 h-96 border border-[#d4af37] rounded-full animate-pulse"></div>
          <div className="absolute bottom-1/4 left-1/4 w-64 h-64 border border-[#d4af37] rounded-full animate-pulse" style={{ animationDelay: '1s' }}></div>
        </div>

        <div className="max-w-7xl mx-auto px-6 relative z-10">
          {/* 標題 */}
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-white mb-2" style={{ fontFamily: "'Noto Serif SC', serif" }}>
              最新拍品預覽
            </h2>
            <p className="text-[#d4af37]/80 text-base">即將上拍 · 搶先預覽</p>
          </div>

          {/* 輪播容器 */}
          <div className="relative">
            {/* 主輪播區 */}
            <div className="overflow-hidden rounded-3xl">
              <div 
                className="flex transition-transform duration-500 ease-out"
                style={{ transform: `translateX(-${currentAuctionSlide * 100}%)` }}
              >
                {upcomingAuctions.map((item, index) => (
                  <div key={index} className="w-full flex-shrink-0 px-4">
                    <div className="bg-white/5 backdrop-blur-sm border-2 border-[#d4af37]/40 rounded-3xl overflow-hidden hover:border-[#d4af37]/70 transition-all duration-300 group">
                      <div className="grid md:grid-cols-2 gap-8 p-8">
                        {/* 左側圖片 */}
                        <div className="relative">
                          <div className="aspect-square rounded-2xl overflow-hidden border-4 border-[#d4af37]/30 group-hover:border-[#d4af37]/60 transition-all">
                            <img
                              src={item.image}
                              alt={item.name}
                              className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                            />
                          </div>
                          {/* LOT 編號 */}
                          <div className="absolute top-4 right-4 bg-[#d4af37] text-[#1a3a2e] px-4 py-2 rounded-full font-bold text-sm shadow-lg whitespace-nowrap">
                            {item.lot}
                          </div>
                          {/* 類別標籤 */}
                          <div className={`absolute bottom-4 left-4 ${item.categoryColor} text-white px-4 py-2 rounded-full font-bold text-sm shadow-lg whitespace-nowrap`}>
                            {item.category}
                          </div>
                        </div>

                        {/* 右側資訊 */}
                        <div className="flex flex-col justify-center">
                          <div className="inline-block border border-[#d4af37]/60 text-[#d4af37] px-4 py-1 rounded-full text-xs tracking-widest mb-6 w-fit whitespace-nowrap">
                            即將上拍
                          </div>
                          
                          <h3 className="text-3xl font-bold text-white mb-6 leading-snug" style={{ fontFamily: "'Noto Serif SC', serif" }}>
                            {item.name}
                          </h3>

                          <div className="space-y-4 mb-8">
                            <div className="flex items-center gap-3">
                              <div className="w-10 h-10 bg-[#d4af37]/20 rounded-full flex items-center justify-center flex-shrink-0">
                                <i className="ri-auction-line text-[#d4af37] text-xl"></i>
                              </div>
                              <div>
                                <p className="text-white/60 text-sm">起拍價</p>
                                <p className="text-2xl font-bold text-[#d4af37]">{item.startPrice}</p>
                              </div>
                            </div>

                            <div className="flex items-center gap-3">
                              <div className="w-10 h-10 bg-[#d4af37]/20 rounded-full flex items-center justify-center flex-shrink-0">
                                <i className="ri-calendar-event-line text-[#d4af37] text-xl"></i>
                              </div>
                              <div>
                                <p className="text-white/60 text-sm">拍賣時間</p>
                                <p className="text-lg font-semibold text-white">本週六 20:00 直播</p>
                              </div>
                            </div>
                          </div>

                          <div className="flex gap-4">
                            <a
                              href="tel:0916661789"
                              className="flex-1 bg-[#d4af37] text-[#1a3a2e] px-6 py-3 rounded-full text-base font-bold hover:bg-[#c19b2e] transition-all hover:scale-105 cursor-pointer whitespace-nowrap text-center flex items-center justify-center gap-2"
                            >
                              <i className="ri-phone-fill"></i>
                              預約競標
                            </a>
                            <button
                              onClick={() => scrollToSection('live-preview')}
                              className="flex-1 border-2 border-[#d4af37] text-white px-6 py-3 rounded-full text-base font-semibold hover:bg-[#d4af37]/20 transition-all hover:scale-105 cursor-pointer whitespace-nowrap text-center flex items-center justify-center gap-2"
                            >
                              <i className="ri-live-line"></i>
                              查看直播
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* 左右箭頭 */}
            <button
              onClick={prevAuctionSlide}
              className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 w-12 h-12 bg-[#d4af37] rounded-full flex items-center justify-center hover:bg-[#c19b2e] transition-all hover:scale-110 cursor-pointer shadow-xl z-10"
              aria-label="上一張"
            >
              <i className="ri-arrow-left-s-line text-[#1a3a2e] text-2xl"></i>
            </button>
            <button
              onClick={nextAuctionSlide}
              className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 w-12 h-12 bg-[#d4af37] rounded-full flex items-center justify-center hover:bg-[#c19b2e] transition-all hover:scale-110 cursor-pointer shadow-xl z-10"
              aria-label="下一張"
            >
              <i className="ri-arrow-right-s-line text-[#1a3a2e] text-2xl"></i>
            </button>

            {/* 底部圓點指示器 */}
            <div className="flex items-center justify-center gap-3 mt-8">
              {upcomingAuctions.map((_, index) => (
                <button
                  key={index}
                  onClick={() => goToAuctionSlide(index)}
                  className={`transition-all cursor-pointer ${
                    currentAuctionSlide === index
                      ? 'w-8 h-3 bg-[#d4af37] rounded-full'
                      : 'w-3 h-3 bg-white/30 rounded-full hover:bg-white/50'
                  }`}
                  aria-label={`前往第 ${index + 1} 張`}
                ></button>
              ))}
            </div>
          </div>

          {/* 底部提示 */}
          <div className="mt-10 text-center">
            <div className="inline-flex items-center gap-3 bg-white/5 backdrop-blur-sm border border-[#d4af37]/30 rounded-full px-8 py-4">
              <i className="ri-information-line text-[#d4af37] text-xl"></i>
              <p className="text-white text-base">
                更多精品將於<strong className="text-[#d4af37]">本週六晚上 20:00</strong> 直播拍賣中呈現
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 直播拍賣預告區 */}
      <section id="live-preview" className="py-20 bg-gradient-to-br from-[#0d1f17] via-[#1a3a2e] to-[#0d1f17] relative overflow-hidden">
        {/* 裝飾背景 */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-1/4 w-96 h-96 border border-[#d4af37] rounded-full animate-pulse"></div>
          <div className="absolute bottom-0 right-1/4 w-64 h-64 border border-[#d4af37] rounded-full animate-pulse" style={{ animationDelay: '1s' }}></div>
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] border border-[#d4af37]/30 rounded-full"></div>
        </div>

        <div className="max-w-7xl mx-auto px-6 relative z-10">
          {/* 標題 */}
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-white mb-2" style={{ fontFamily: "'Noto Serif SC', serif" }}>
              直播
            </h2>
            <p className="text-[#d4af37]/80 text-base">每週六晚上 20:00 準時開播</p>
          </div>

          {/* 主內容區 */}
          <div className="grid lg:grid-cols-2 gap-8 md:gap-12 items-start">
            {/* 左側：倒數計時與資訊 */}
            <div>
              {/* 倒數計時器 */}
              <div className="bg-gradient-to-br from-[#d4af37]/20 to-transparent border-2 border-[#d4af37]/40 rounded-3xl p-5 sm:p-8 md:p-10 mb-6 md:mb-8">
                <div className="text-center mb-5 md:mb-8">
                  <p className="text-white/80 text-sm md:text-lg mb-3 md:mb-2">距離下次直播還有</p>
                  <div className="grid grid-cols-4 gap-2 sm:gap-3 md:gap-4">
                    {[
                      { label: '天', value: timeLeft.days },
                      { label: '時', value: timeLeft.hours },
                      { label: '分', value: timeLeft.minutes },
                      { label: '秒', value: timeLeft.seconds }
                    ].map((item, index) => (
                      <div key={index} className="bg-white/10 backdrop-blur-sm rounded-xl md:rounded-2xl p-2 sm:p-3 md:p-4 border border-[#d4af37]/30">
                        <div className="text-2xl sm:text-3xl md:text-5xl font-bold text-[#d4af37] mb-1">{String(item.value).padStart(2, '0')}</div>
                        <div className="text-white/70 text-xs md:text-sm">{item.label}</div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* 直播資訊 */}
                <div className="space-y-4">
                  <div className="flex items-center gap-3 text-white">
                    <div className="w-10 h-10 bg-[#d4af37]/20 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-calendar-line text-[#d4af37] text-xl"></i>
                    </div>
                    <div>
                      <p className="text-white/60 text-sm">直播時間</p>
                      <p className="text-lg font-semibold">每週六 晚上 20:00</p>
                    </div>
                  </div>

                  <div className="flex items-center gap-3 text-white">
                    <div className="w-10 h-10 bg-[#d4af37]/20 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-live-line text-[#d4af37] text-xl"></i>
                    </div>
                    <div>
                      <p className="text-white/60 text-sm">本期主題</p>
                      <p className="text-lg font-semibold">壽山石精品專場</p>
                    </div>
                  </div>

                  <div className="flex items-center gap-3 text-white">
                    <div className="w-10 h-10 bg-[#d4af37]/20 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-tv-line text-[#d4af37] text-xl"></i>
                    </div>
                    <div>
                      <p className="text-white/60 text-sm">直播平台</p>
                      <p className="text-lg font-semibold">抖音 · 快手 · 微信視頻號</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* 預約按鈕 */}
              <div className="flex flex-col sm:flex-row gap-4">
                <a 
                  href="tel:0916661789" 
                  className="flex-1 bg-[#d4af37] text-[#1a3a2e] px-8 py-4 rounded-full text-lg font-bold hover:bg-[#c19b2e] transition-all hover:scale-105 cursor-pointer whitespace-nowrap text-center flex items-center justify-center gap-3"
                >
                  <i className="ri-phone-fill text-xl"></i>
                  電話預約提醒
                </a>
                <a 
                  href="https://line.me/ti/p/~twgtart" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex-1 bg-[#06C755] text-white px-8 py-4 rounded-full text-lg font-bold hover:bg-[#05b04b] transition-all hover:scale-105 cursor-pointer whitespace-nowrap text-center flex items-center justify-center gap-3"
                >
                  <i className="ri-chat-smile-2-fill text-xl"></i>
                  LINE 預約提醒
                </a>
              </div>
            </div>

            {/* 右側：預計拍品 */}
            <div>
              <div className="bg-white/5 backdrop-blur-sm border border-[#d4af37]/30 rounded-3xl p-8">
                <h3 className="text-2xl font-bold text-white mb-6 flex items-center gap-3">
                  <i className="ri-auction-line text-[#d4af37]"></i>
                  本期預計拍品
                </h3>

                <div className="space-y-4">
                  {[
                    {
                      name: '田黃石印章',
                      desc: '清代田黃石雕刻印章，色澤金黃，質地溫潤',
                      estimate: '起拍價：NT$ 180,000',
                      image: 'https://readdy.ai/api/search-image?query=Exquisite%20Tianhuang%20Shoushan%20stone%20seal%20with%20golden%20yellow%20color%20and%20smooth%20texture%2C%20traditional%20Chinese%20carved%20seal%20with%20intricate%20dragon%20pattern%2C%20displayed%20on%20dark%20wooden%20stand%20against%20simple%20gradient%20background%2C%20professional%20studio%20lighting%20highlighting%20natural%20translucency%2C%20museum%20quality%20presentation&width=300&height=300&seq=auction-item-tianhuang-001&orientation=squarish'
                    },
                    {
                      name: '芙蓉石雕件',
                      desc: '頂級芙蓉石雕刻作品，粉色細膩，工藝精湛',
                      estimate: '起拍價：NT$ 120,000',
                      image: 'https://readdy.ai/api/search-image?query=Premium%20Furong%20Shoushan%20stone%20carving%20with%20delicate%20pink%20color%20and%20fine%20texture%2C%20featuring%20elegant%20floral%20or%20landscape%20motifs%2C%20displayed%20on%20dark%20wooden%20stand%20against%20simple%20gradient%20background%2C%20soft%20professional%20lighting%20emphasizing%20the%20stones%20natural%20beauty%2C%20refined%20artistic%20presentation&width=300&height=300&seq=auction-item-furong-001&orientation=squarish'
                    },
                    {
                      name: '雞血石擺件',
                      desc: '雞血石精品擺件，色彩豐富，紋理獨特',
                      estimate: '起拍價：NT$ 95,000',
                      image: 'https://readdy.ai/api/search-image?query=Colorful%20Gaoshan%20Shoushan%20stone%20decorative%20piece%20with%20vibrant%20multi-colored%20patterns%20and%20unique%20natural%20textures%2C%20traditional%20Chinese%20carved%20ornament%20with%20auspicious%20symbols%2C%20displayed%20on%20dark%20wooden%20stand%20against%20simple%20gradient%20background%2C%20professional%20lighting%20showcasing%20rich%20colors%2C%20elegant%20presentation&width=300&height=300&seq=auction-item-gaoshan-001&orientation=squarish'
                    },
                    {
                      name: '壽山石雕龍',
                      desc: '壽山石雕刻神龍，氣勢磅礴，收藏佳品',
                      estimate: '起拍價：NT$ 150,000',
                      image: 'https://readdy.ai/api/search-image?query=Magnificent%20Shoushan%20stone%20dragon%20carving%20with%20powerful%20presence%20and%20intricate%20details%2C%20featuring%20vibrant%20red%20and%20golden%20colors%2C%20traditional%20Chinese%20dragon%20sculpture%20with%20dynamic%20pose%2C%20displayed%20on%20dark%20wooden%20stand%20against%20simple%20gradient%20background%2C%20dramatic%20lighting%20emphasizing%20craftsmanship%2C%20prestigious%20collectible%20presentation&width=300&height=300&seq=auction-item-dragon-001&orientation=squarish'
                    }
                  ].map((item, index) => (
                    <div key={index} className="bg-white/5 border border-[#d4af37]/20 rounded-2xl p-4 hover:bg-white/10 hover:border-[#d4af37]/40 transition-all group cursor-pointer">
                      <div className="flex gap-4">
                        <div className="w-24 h-24 flex-shrink-0 rounded-xl overflow-hidden">
                          <img 
                            src={item.image}
                            alt={item.name}
                            className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                          />
                        </div>
                        <div className="flex-1">
                          <div className="flex items-start justify-between mb-2">
                            <h4 className="text-lg font-bold text-white group-hover:text-[#d4af37] transition-colors">{item.name}</h4>
                            <span className="text-[#d4af37] text-sm font-semibold whitespace-nowrap ml-2">LOT {index + 1}</span>
                          </div>
                          <p className="text-white/70 text-sm mb-2 line-clamp-2">{item.desc}</p>
                          <p className="text-[#d4af37] text-sm font-semibold">{item.estimate}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="mt-6 pt-6 border-t border-[#d4af37]/20">
                  <p className="text-white/60 text-sm text-center">
                    <i className="ri-information-line mr-2"></i>
                    更多精品將於直播中陸續呈現
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* 底部提示 */}
          <div className="mt-10 text-center">
            <div className="inline-flex items-center gap-3 bg-white/5 backdrop-blur-sm border border-[#d4af37]/30 rounded-full px-8 py-4">
              <i className="ri-star-fill text-[#d4af37] text-xl"></i>
              <p className="text-white text-base">
                <strong className="text-[#d4af37]">保真承諾</strong> · 專業鑒定 · 全程直播透明
              </p>
              <i className="ri-star-fill text-[#d4af37] text-xl"></i>
            </div>
          </div>
        </div>
      </section>

      {/* 直播回放專區 */}
      <section id="live-replay" className="py-20 bg-gradient-to-br from-[#1a3a2e] via-[#0d1f17] to-[#1a3a2e] relative overflow-hidden">
        {/* 裝飾背景 */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-1/4 left-1/4 w-80 h-80 border border-[#d4af37] rounded-full"></div>
          <div className="absolute bottom-1/4 right-1/4 w-96 h-96 border border-[#d4af37] rounded-full animate-pulse" style={{ animationDelay: '1.5s' }}></div>
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] border border-[#d4af37]/20 rounded-full"></div>
        </div>

        <div className="max-w-7xl mx-auto px-6 relative z-10">
          {/* 標題 */}
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-white mb-2" style={{ fontFamily: "'Noto Serif SC', serif" }}>
              直播回放
            </h2>
            <p className="text-[#d4af37]/80 text-base">回顧精彩拍賣瞬間 · 感受現場競標氛圍</p>
          </div>

          {/* 回放卡片網格 */}
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
            {[
              {
                title: '壽山石精品專場',
                date: '2024年12月14日',
                views: '12,580',
                tags: ['田黃石', '芙蓉石', '雞血石'],
                image: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20antique%20live%20auction%20scene%20with%20auctioneer%20presenting%20exquisite%20Shoushan%20stone%20carvings%20on%20elegant%20display%20stands%2C%20modern%20auction%20house%20interior%20with%20professional%20lighting%20and%20multiple%20cameras%2C%20audience%20members%20viewing%20and%20bidding%2C%20dynamic%20and%20engaging%20atmosphere%20with%20red%20and%20golden%20accents%2C%20high-end%20broadcast%20quality&width=600&height=400&seq=live-replay-shoushan-001&orientation=landscape'
              },
              {
                title: '名家字畫拍賣會',
                date: '2024年12月7日',
                views: '9,340',
                tags: ['齊白石', '張大千', '近代名家'],
                image: 'https://readdy.ai/api/search-image?query=Chinese%20calligraphy%20and%20painting%20auction%20live%20broadcast%20scene%2C%20featuring%20elegant%20scrolls%20displayed%20on%20easels%20with%20professional%20spotlights%2C%20auctioneer%20in%20traditional%20Chinese%20attire%20presenting%20artwork%2C%20sophisticated%20auction%20hall%20with%20bidders%20raising%20paddles%2C%20cultural%20and%20refined%20atmosphere&width=600&height=400&seq=live-replay-calligraphy-001&orientation=landscape'
              },
              {
                title: '翡翠珠寶專場',
                date: '2024年11月30日',
                views: '15,620',
                tags: ['冰種翡翠', '和田玉', '寶石'],
                image: 'https://readdy.ai/api/search-image?query=Luxury%20jade%20and%20jewelry%20auction%20live%20streaming%20scene%2C%20featuring%20translucent%20emerald%20green%20jade%20pieces%20under%20professional%20jewelry%20lighting%2C%20auctioneer%20presenting%20items%20with%20white%20gloves%2C%20elegant%20auction%20house%20with%20bidders%2C%20high-end%20sophisticated%20atmosphere%20with%20golden%20accents&width=600&height=400&seq=live-replay-jade-001&orientation=landscape'
              },
              {
                title: '西藏天珠專場',
                date: '2024年11月23日',
                views: '11,280',
                tags: ['九眼天珠', '老天珠', '至純天珠'],
                image: 'https://readdy.ai/api/search-image?query=Tibetan%20Dzi%20bead%20auction%20live%20broadcast%20scene%2C%20featuring%20ancient%20agate%20beads%20with%20eye%20patterns%20displayed%20on%20traditional%20Tibetan%20silk%20fabric%2C%20auctioneer%20presenting%20sacred%20artifacts%2C%20warm%20ambient%20lighting%20creating%20mystical%20atmosphere%2C%20bidders%20showing%20reverence%20and%20interest&width=600&height=400&seq=live-replay-dzi-001&orientation=landscape'
              },
              {
                title: '佛像藝術專場',
                date: '2024年11月16日',
                views: '8,950',
                tags: ['明清銅像', '藏傳佛教', '鎏金佛像'],
                image: 'https://readdy.ai/api/search-image?query=Buddhist%20statue%20auction%20live%20streaming%20scene%2C%20featuring%20golden%20bronze%20Buddha%20sculptures%20with%20serene%20expressions%20on%20elegant%20pedestals%2C%20professional%20museum%20lighting%2C%20auctioneer%20presenting%20religious%20artifacts%20with%20respect%2C%20sacred%20and%20cultural%20atmosphere%20in%20auction%20hall&width=600&height=400&seq=live-replay-buddha-001&orientation=landscape'
              },
              {
                title: '綜合古董專場',
                date: '2024年11月9日',
                views: '13,470',
                tags: ['瓷器', '玉器', '雜項'],
                image: 'https://readdy.ai/api/search-image?query=Chinese%20antique%20mixed%20auction%20live%20broadcast%20scene%2C%20featuring%20various%20ancient%20artifacts%20including%20porcelain%20vases%2C%20jade%20ornaments%20and%20collectibles%20on%20display%20stands%2C%20professional%20auction%20house%20interior%20with%20multiple%20cameras%2C%20auctioneer%20presenting%20items%2C%20engaged%20bidders%2C%20prestigious%20atmosphere&width=600&height=400&seq=live-replay-mixed-001&orientation=landscape'
              },
              {
                title: '壽山石雕刻專場',
                date: '2024年11月2日',
                views: '10,820',
                tags: ['精品雕件', '印章', '擺件'],
                image: 'https://readdy.ai/api/search-image?query=Shoushan%20stone%20carving%20auction%20live%20streaming%20scene%2C%20featuring%20intricately%20carved%20stone%20pieces%20with%20vibrant%20colors%20displayed%20on%20dark%20wooden%20stands%2C%20close-up%20shots%20showing%20fine%20craftsmanship%20details%2C%20professional%20lighting%20emphasizing%20translucency%2C%20auctioneer%20presenting%20masterpieces%2C%20collectors%20bidding%20enthusiastically&width=600&height=400&seq=live-replay-carving-001&orientation=landscape'
              },
              {
                title: '珍稀天珠專場',
                date: '2024年10月26日',
                views: '14,590',
                tags: ['三眼天珠', '虎牙天珠', '稀有品種'],
                image: 'https://readdy.ai/api/search-image?query=Rare%20Tibetan%20Dzi%20bead%20auction%20live%20broadcast%20scene%2C%20featuring%20unique%20three-eye%20and%20tiger%20tooth%20Dzi%20beads%20with%20distinctive%20patterns%20on%20traditional%20fabric%2C%20macro%20camera%20shots%20showing%20intricate%20details%2C%20warm%20lighting%20creating%20sacred%20atmosphere%2C%20auctioneer%20presenting%20rare%20specimens%2C%20serious%20collectors%20bidding&width=600&height=400&seq=live-replay-rare-dzi-001&orientation=landscape'
              }
            ].map((replay, index) => (
              <div 
                key={index} 
                className="bg-white/5 backdrop-blur-sm border border-[#d4af37]/30 rounded-2xl overflow-hidden hover:border-[#d4af37]/60 hover:bg-white/10 transition-all duration-300 group cursor-pointer"
                onClick={() => handleReplayClick(replay.title)}
              >
                {/* 縮圖 */}
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={replay.image}
                    alt={replay.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                  
                  {/* 播放按鈕 */}
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-16 h-16 bg-[#d4af37]/90 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform">
                      <i className="ri-play-fill text-[#1a3a2e] text-3xl ml-1"></i>
                    </div>
                  </div>

                  {/* 觀看人數 */}
                  <div className="absolute top-3 right-3 bg-black/60 backdrop-blur-sm rounded-full px-3 py-1 flex items-center gap-2">
                    <i className="ri-eye-line text-white text-sm"></i>
                    <span className="text-white text-xs font-semibold whitespace-nowrap">{replay.views}</span>
                  </div>
                </div>

                {/* 內容 */}
                <div className="p-5">
                  <h3 className="text-lg font-bold text-white mb-2 group-hover:text-[#d4af37] transition-colors">{replay.title}</h3>
                  <p className="text-white/60 text-sm mb-3 flex items-center gap-2">
                    <i className="ri-calendar-line"></i>
                    {replay.date}
                  </p>

                  {/* 標籤 */}
                  <div className="flex flex-wrap gap-2">
                    {replay.tags.map((tag, ti) => (
                      <span key={ti} className="bg-[#d4af37]/20 text-[#d4af37] text-xs px-3 py-1 rounded-full border border-[#d4af37]/30 whitespace-nowrap">
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* 底部提示 */}
          <div className="text-center">
            <div className="inline-flex flex-col items-center gap-4 bg-white/5 backdrop-blur-sm border border-[#d4af37]/30 rounded-2xl px-10 py-6">
              <div className="flex items-center gap-3">
                <i className="ri-information-line text-[#d4af37] text-2xl"></i>
                <p className="text-white text-lg">
                  想觀看完整直播回放？
                </p>
              </div>
              <div className="flex flex-wrap items-center justify-center gap-4">
                <a
                  href="tel:0916661789"
                  className="bg-[#d4af37] text-[#1a3a2e] px-8 py-3 rounded-full text-lg font-bold hover:bg-[#c19b2e] transition-all hover:scale-105 cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
                >
                  <i className="ri-phone-fill"></i>
                  電話聯繫 0916-661789
                </a>
                
                <a
                  href="https://www.youtube.com/@光特藝術拍賣"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-red-600 text-white px-8 py-3 rounded-full text-lg font-bold hover:bg-red-700 transition-all hover:scale-105 cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
                >
                  <i className="ri-youtube-fill"></i>
                  YouTube 頻道
                </a>

                <div className="pt-4 border-t border-white/20 w-full text-center">
                  <p className="text-white/50 text-sm">
                    <i className="ri-mail-line mr-2"></i>
                    Email: twgtart@gmail.com
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 回放彈窗 */}
      {showReplayModal && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-6" onClick={closeReplayModal}>
          <div className="bg-gradient-to-br from-[#1a3a2e] to-[#0d1f17] border-2 border-[#d4af37]/50 rounded-3xl p-8 max-w-lg w-full relative" onClick={(e) => e.stopPropagation()}>
            <button
              onClick={closeReplayModal}
              className="absolute top-4 right-4 w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors cursor-pointer"
            >
              <i className="ri-close-line text-white text-xl"></i>
            </button>

            <div className="text-center">
              <div className="w-20 h-20 bg-[#d4af37]/20 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-play-circle-line text-[#d4af37] text-5xl"></i>
              </div>
              
              <h3 className="text-3xl font-bold text-white mb-4">{selectedReplay}</h3>
              <p className="text-white/70 text-lg mb-8 leading-relaxed">
                完整直播回放影片請透過以下方式聯繫我們獲取觀看連結
              </p>

              <div className="space-y-4">
                <a
                  href="tel:0916661789"
                  className="block w-full bg-[#d4af37] text-[#1a3a2e] px-8 py-4 rounded-xl text-lg font-bold hover:bg-[#c19b2e] transition-all hover:scale-105 cursor-pointer whitespace-nowrap flex items-center justify-center gap-3"
                >
                  <i className="ri-phone-fill text-xl"></i>
                  電話聯繫 0916-661789
                </a>
                
                <a
                  href="https://www.youtube.com/@光特藝術拍賣"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block w-full bg-red-600 text-white px-8 py-4 rounded-xl text-lg font-bold hover:bg-red-700 transition-all hover:scale-105 cursor-pointer whitespace-nowrap flex items-center justify-center gap-3"
                >
                  <i className="ri-youtube-fill text-xl"></i>
                  YouTube 頻道觀看
                </a>

                <div className="pt-4 border-t border-white/20">
                  <p className="text-white/50 text-sm">
                    <i className="ri-mail-line mr-2"></i>
                    Email: twgtart@gmail.com
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* 線上預約送拍彈窗 */}
      {showBookingModal && (
        <div 
          className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-6 overflow-y-auto"
          onClick={() => setShowBookingModal(false)}
        >
          <div 
            className="bg-gradient-to-br from-[#1a3a2e] to-[#0d1f17] border-2 border-[#d4af37]/50 rounded-3xl p-8 max-w-2xl w-full relative my-8"
            onClick={(e) => e.stopPropagation()}
          >
            {/* 關閉按鈕 */}
            <button
              onClick={() => setShowBookingModal(false)}
              className="absolute top-6 right-6 w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors cursor-pointer"
            >
              <i className="ri-close-line text-white text-2xl"></i>
            </button>

            {/* 標題 */}
            <div className="text-center mb-8">
              <div className="w-16 h-16 bg-[#d4af37]/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-calendar-check-line text-[#d4af37] text-3xl"></i>
              </div>
              <h3 className="text-3xl font-bold text-white mb-2">線上預約送拍</h3>
              <p className="text-white/70 text-base">填寫預約資訊，我們將盡快與您聯繫安排送拍事宜</p>
            </div>

            {/* 表單 */}
            <form data-readdy-form onSubmit={handleBookingSubmit} className="space-y-5">
              {/* 姓名 & 聯繫方式 */}
              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <label htmlFor="booking-name" className="block text-white text-sm font-semibold mb-2">
                    姓名 <span className="text-[#d4af37]">*</span>
                  </label>
                  <input
                    type="text"
                    id="booking-name"
                    name="name"
                    value={bookingFormData.name}
                    onChange={handleBookingInputChange}
                    required
                    className="w-full px-4 py-3 bg-white/10 border border-[#d4af37]/40 rounded-xl text-white placeholder-white/40 focus:outline-none focus:border-[#d4af37] focus:bg-white/15 transition-all text-sm"
                    placeholder="請輸入您的姓名"
                  />
                </div>

                <div>
                  <label htmlFor="booking-contact" className="block text-white text-sm font-semibold mb-2">
                    聯繫電話/LINE/微信 <span className="text-[#d4af37]">*</span>
                  </label>
                  <input
                    type="text"
                    id="booking-contact"
                    name="contact"
                    value={bookingFormData.contact}
                    onChange={handleBookingInputChange}
                    required
                    className="w-full px-4 py-3 bg-white/10 border border-[#d4af37]/40 rounded-xl text-white placeholder-white/40 focus:outline-none focus:border-[#d4af37] focus:bg-white/15 transition-all text-sm"
                    placeholder="電話、LINE ID 或微信 ID"
                  />
                </div>
              </div>

              {/* Email */}
              <div>
                <label htmlFor="booking-email" className="block text-white text-sm font-semibold mb-2">
                  Email 信箱 <span className="text-[#d4af37]">*</span>
                </label>
                <input
                  type="email"
                  id="booking-email"
                  name="email"
                  value={bookingFormData.email}
                  onChange={handleBookingInputChange}
                  required
                  className="w-full px-4 py-3 bg-white/10 border border-[#d4af37]/40 rounded-xl text-white placeholder-white/40 focus:outline-none focus:border-[#d4af37] focus:bg-white/15 transition-all text-sm"
                  placeholder="用於接收預約確認通知"
                />
              </div>

              {/* 藏品類型 & 預約時間 */}
              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <label htmlFor="booking-itemType" className="block text-white text-sm font-semibold mb-2">
                    藏品類型 <span className="text-[#d4af37]">*</span>
                  </label>
                  <select
                    id="booking-itemType"
                    name="itemType"
                    value={bookingFormData.itemType}
                    onChange={handleBookingInputChange}
                    required
                    className="w-full px-4 py-3 bg-[#1a3a2e] border border-[#d4af37]/40 rounded-xl text-white focus:outline-none focus:border-[#d4af37] transition-all cursor-pointer text-sm"
                  >
                    <option value="">請選擇藏品類型</option>
                    <option value="中國書畫">中國書畫</option>
                    <option value="古董珍玩">古董珍玩</option>
                    <option value="郵品錢幣">郵品錢幣</option>
                    <option value="青銅佛像">青銅佛像</option>
                    <option value="古玩玉器">古玩玉器</option>
                    <option value="金石碑帖">金石碑帖</option>
                    <option value="明清家具">明清家具</option>
                    <option value="古籍善本">古籍善本</option>
                    <option value="珠寶翡翠">珠寶翡翠</option>
                    <option value="造像藝術">造像藝術</option>
                    <option value="名酒茗品">名酒茗品</option>
                    <option value="西方古物">西方古物</option>
                    <option value="壽山石">壽山石</option>
                    <option value="其他">其他</option>
                  </select>
                </div>

                <div>
                  <label htmlFor="booking-appointmentDate" className="block text-white text-sm font-semibold mb-2">
                    預約時間 <span className="text-[#d4af37]">*</span>
                  </label>
                  <input
                    type="date"
                    id="booking-appointmentDate"
                    name="appointmentDate"
                    value={bookingFormData.appointmentDate}
                    onChange={handleBookingInputChange}
                    required
                    min={new Date().toISOString().split('T')[0]}
                    className="w-full px-4 py-3 bg-white/10 border border-[#d4af37]/40 rounded-xl text-white focus:outline-none focus:border-[#d4af37] focus:bg-white/15 transition-all text-sm"
                  />
                </div>
              </div>

              {/* 所在地區 */}
              <div>
                <label htmlFor="booking-location" className="block text-white text-sm font-semibold mb-2">
                  所在地區 <span className="text-[#d4af37]">*</span>
                </label>
                <select
                  id="booking-location"
                  name="location"
                  value={bookingFormData.location}
                  onChange={handleBookingInputChange}
                  required
                  className="w-full px-4 py-3 bg-[#1a3a2e] border border-[#d4af37]/40 rounded-xl text-white focus:outline-none focus:border-[#d4af37] transition-all cursor-pointer text-sm"
                >
                  <option value="">請選擇所在地區</option>
                  <option value="台灣">台灣</option>
                  <option value="大陸">大陸</option>
                  <option value="海外">海外</option>
                </select>
              </div>

              {/* 藏品簡述 */}
              <div>
                <label htmlFor="booking-description" className="block text-white text-sm font-semibold mb-2">
                  藏品簡述 <span className="text-[#d4af37]">*</span>
                  <span className="text-xs text-white/50 ml-2">（限300字）</span>
                </label>
                <textarea
                  id="booking-description"
                  name="description"
                  value={bookingFormData.description}
                  onChange={handleBookingInputChange}
                  required
                  maxLength={300}
                  rows={4}
                  className="w-full px-4 py-3 bg-white/10 border border-[#d4af37]/40 rounded-xl text-white placeholder-white/40 focus:outline-none focus:border-[#d4af37] focus:bg-white/15 transition-all resize-none text-sm"
                  placeholder="請簡述藏品的類型、尺寸、年代、來源等資訊..."
                ></textarea>
                <div className="flex justify-end mt-1">
                  <span className={`text-xs ${bookingFormData.description.length > 280 ? 'text-red-400' : 'text-white/50'}`}>
                    {bookingFormData.description.length}/300
                  </span>
                </div>
              </div>

              {/* 提交按鈕 */}
              <button
                type="submit"
                disabled={bookingFormStatus === 'submitting'}
                className="w-full bg-[#d4af37] text-[#1a3a2e] px-8 py-4 rounded-xl text-lg font-bold hover:bg-[#c19b2e] transition-all hover:scale-[1.02] disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer whitespace-nowrap flex items-center justify-center gap-3"
              >
                {bookingFormStatus === 'submitting' ? (
                  <>
                    <i className="ri-loader-4-line animate-spin text-xl"></i>
                    提交中...
                  </>
                ) : (
                  <>
                    <i className="ri-send-plane-fill text-xl"></i>
                    提交預約申請
                  </>
                )}
              </button>

              {/* 成功提示 */}
              {bookingFormStatus === 'success' && (
                <div className="bg-green-500/20 border border-green-500/50 rounded-xl p-4 flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-green-400 text-2xl flex-shrink-0"></i>
                  <div>
                    <p className="text-green-400 font-bold text-base">預約提交成功！🎉</p>
                    <p className="text-white/80 text-sm mt-1">我們已收到您的預約申請，將在24小時內與您聯繫確認送拍事宜。</p>
                  </div>
                </div>
              )}

              {/* 錯誤提示 */}
              {bookingFormStatus === 'error' && (
                <div className="bg-red-500/20 border border-red-500/50 rounded-xl p-4 flex items-center gap-3">
                  <i className="ri-error-warning-fill text-red-400 text-xl"></i>
                  <div>
                    <p className="text-red-400 font-semibold text-sm">提交失敗，請稍後再試</p>
                    <p className="text-white/70 text-xs">或直接撥打 <a href="tel:0916661789" className="text-[#d4af37] font-bold">0916-661789</a></p>
                  </div>
                </div>
              )}
            </form>

            {/* 底部提示 */}
            <div className="mt-6 pt-6 border-t border-white/20">
              <p className="text-white/60 text-xs text-center">
                <i className="ri-information-line mr-1"></i>
                預約成功後，我們將與您聯繫確認具體送拍時間與方式
              </p>
            </div>
          </div>
        </div>
      )}

      {/* 2025 全球藝術品拍賣會徵集專區 */}
      <section id="collection-2025" className="py-20 bg-gradient-to-br from-[#f5f5f0] via-white to-[#f5f5f0] relative overflow-hidden">
        {/* 裝飾背景 */}
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-[#d4af37]/5 rounded-full -translate-y-1/2 translate-x-1/2"></div>
          <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-[#1a3a2e]/5 rounded-full translate-y-1/2 -translate-x-1/2"></div>
        </div>

        <div className="max-w-7xl mx-auto px-6 relative z-10">
          {/* 標題區 */}
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-[#1a3a2e] mb-3" style={{ fontFamily: "'Noto Serif SC', serif" }}>
              2025 藝術品拍賣會 · 全球徵集
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto text-base leading-relaxed">
              台北光特專家團隊提供<strong className="text-[#1a3a2e]">免費藝術品上拍評估與諮詢</strong>，歡迎各地藏家蒞臨，共享珍品。
            </p>
          </div>

          {/* 宣傳海報展示區 */}
          <div className="flex justify-center mb-14">
            <div className="relative group">
              {/* 裝飾邊框 */}
              <div className="absolute -inset-3 bg-gradient-to-br from-[#d4af37]/30 to-[#1a3a2e]/20 rounded-3xl blur-xl opacity-60 group-hover:opacity-90 transition-opacity duration-500"></div>
              <div className="absolute -inset-1 border-2 border-[#d4af37]/50 rounded-2xl rotate-1"></div>
              <div className="absolute -inset-1 border-2 border-[#d4af37]/30 rounded-2xl -rotate-1"></div>
              {/* 海報圖片 */}
              <div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-[#d4af37]/60" style={{ width: '380px', height: '680px' }}>
                <img
                  src="https://static.readdy.ai/image/4f3f06d226654fda02a3ba64a379f0f2/bc5052e3c486440a5e9c7c8ef230e20b.jpeg"
                  alt="2025藝術品拍賣會公開徵集海報"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              {/* 角落裝飾 */}
              <div className="absolute top-3 left-3 w-6 h-6 border-t-2 border-l-2 border-[#d4af37]"></div>
              <div className="absolute top-3 right-3 w-6 h-6 border-t-2 border-r-2 border-[#d4af37]"></div>
              <div className="absolute bottom-3 left-3 w-6 h-6 border-b-2 border-l-2 border-[#d4af37]"></div>
              <div className="absolute bottom-3 right-3 w-6 h-6 border-b-2 border-r-2 border-[#d4af37]"></div>
              {/* 標籤 */}
              <div className="absolute -bottom-5 left-1/2 -translate-x-1/2 bg-[#d4af37] text-[#1a3a2e] px-6 py-2 rounded-full font-bold text-sm shadow-xl whitespace-nowrap">
                ✦ 2025 公開徵集 · 全年受理 ✦
              </div>
            </div>
          </div>

          <div className="grid lg:grid-cols-2 gap-12 items-start mb-16">
            {/* 左側：徵集類別 */}
            <div>
              <div className="bg-white rounded-3xl shadow-xl border border-[#f0ebe0] overflow-hidden">
                {/* 卡片標題 */}
                <div className="bg-gradient-to-r from-[#1a3a2e] to-[#2d5a47] px-8 py-6">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-[#d4af37] rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-auction-line text-[#1a3a2e] text-xl"></i>
                    </div>
                    <div>
                      <h4 className="text-2xl font-bold text-white">徵集類別</h4>
                      <p className="text-[#d4af37] text-sm">2025年全年徵集</p>
                    </div>
                  </div>
                </div>

                {/* 類別網格 */}
                <div className="p-8">
                  <div className="grid grid-cols-3 gap-3">
                    {[
                      { icon: 'ri-brush-line', label: '中國書畫' },
                      { icon: 'ri-ancient-pavilion-line', label: '古董珍玩' },
                      { icon: 'ri-mail-line', label: '郵品錢幣' },
                      { icon: 'ri-building-line', label: '青銅佛像' },
                      { icon: 'ri-gem-line', label: '古玩玉器' },
                      { icon: 'ri-file-text-line', label: '金石碑帖' },
                      { icon: 'ri-home-4-line', label: '明清家具' },
                      { icon: 'ri-book-open-line', label: '古籍善本' },
                      { icon: 'ri-vip-diamond-line', label: '珠寶翡翠' },
                      { icon: 'ri-user-star-line', label: '造像藝術' },
                      { icon: 'ri-cup-line', label: '名酒茗品' },
                      { icon: 'ri-global-line', label: '西方古物' },
                    ].map((item, i) => (
                      <div
                        key={i}
                        className="flex flex-col items-center gap-2 bg-gradient-to-br from-[#faf8f3] to-white rounded-xl p-4 border border-[#f0ebe0] hover:border-[#d4af37]/50 hover:shadow-md transition-all group cursor-default"
                      >
                        <div className="w-10 h-10 bg-[#d4af37]/15 rounded-full flex items-center justify-center group-hover:bg-[#d4af37]/30 transition-colors">
                          <i className={`${item.icon} text-[#d4af37] text-lg`}></i>
                        </div>
                        <span className="text-[#1a3a2e] text-xs font-semibold text-center whitespace-nowrap">{item.label}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* 右側：地點 + 聯繫 + 信任點 */}
            <div className="space-y-6">
              {/* 徵集地點 */}
              <div className="bg-white rounded-2xl shadow-lg border border-[#f0ebe0] p-8">
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-10 h-10 bg-[#d4af37]/15 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-2-line text-[#d4af37] text-xl"></i>
                  </div>
                  <h4 className="text-xl font-bold text-[#1a3a2e]">徵集地點</h4>
                </div>
                <div className="space-y-4">
                  <div className="flex items-start gap-4 p-4 bg-[#faf8f3] rounded-xl border border-[#f0ebe0]">
                    <div className="w-8 h-8 bg-[#1a3a2e] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                      <span className="text-white text-xs font-bold">台</span>
                    </div>
                    <div>
                      <p className="font-bold text-[#1a3a2e] mb-1">台灣台北</p>
                      <p className="text-gray-600 text-sm leading-relaxed">大安區建國南路一段327號1樓</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4 p-4 bg-[#faf8f3] rounded-xl border border-[#f0ebe0]">
                    <div className="w-8 h-8 bg-[#d4af37] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                      <span className="text-white text-xs font-bold">陸</span>
                    </div>
                    <div>
                      <p className="font-bold text-[#1a3a2e] mb-1">中國福建福州</p>
                      <p className="text-gray-600 text-sm leading-relaxed">台江區平安大廈11層1107室</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* 聯繫方式 */}
              <div className="bg-white rounded-2xl shadow-lg border border-[#f0ebe0] p-8">
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-10 h-10 bg-[#d4af37]/15 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-contacts-line text-[#d4af37] text-xl"></i>
                  </div>
                  <h4 className="text-xl font-bold text-[#1a3a2e]">聯繫方式</h4>
                </div>
                <div className="space-y-3">
                  <a href="tel:0916661789" className="flex items-center gap-3 p-3 rounded-xl hover:bg-[#faf8f3] transition-colors group cursor-pointer">
                    <div className="w-9 h-9 bg-[#1a3a2e] rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-phone-fill text-white text-sm"></i>
                    </div>
                    <div>
                      <p className="text-xs text-gray-400">台灣電話（同LINE號）</p>
                      <p className="font-bold text-[#1a3a2e] group-hover:text-[#d4af37] transition-colors whitespace-nowrap">0916-661-789</p>
                    </div>
                  </a>
                  <a href="tel:15005000353" className="flex items-center gap-3 p-3 rounded-xl hover:bg-[#faf8f3] transition-colors group cursor-pointer">
                    <div className="w-9 h-9 bg-[#d4af37] rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-phone-fill text-[#1a3a2e] text-sm"></i>
                    </div>
                    <div>
                      <p className="text-xs text-gray-400">大陸電話（同微信號）</p>
                      <p className="font-bold text-[#1a3a2e] group-hover:text-[#d4af37] transition-colors whitespace-nowrap">150-0500-0353</p>
                    </div>
                  </a>
                  <a href="mailto:twgtart@gmail.com" className="flex items-center gap-3 p-3 rounded-xl hover:bg-[#faf8f3] transition-colors group cursor-pointer">
                    <div className="w-9 h-9 bg-[#1a3a2e] rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-mail-fill text-white text-sm"></i>
                    </div>
                    <div>
                      <p className="text-xs text-gray-400">郵箱</p>
                      <p className="font-bold text-[#1a3a2e] group-hover:text-[#d4af37] transition-colors">twgtart@gmail.com</p>
                    </div>
                  </a>
                  <a href="http://app.twgtart.cn/" target="_blank" rel="nofollow noopener noreferrer" className="flex items-center gap-3 p-3 rounded-xl hover:bg-[#faf8f3] transition-colors group cursor-pointer">
                    <div className="w-9 h-9 bg-[#d4af37] rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-global-fill text-[#1a3a2e] text-sm"></i>
                    </div>
                    <div>
                      <p className="text-xs text-gray-400">拍賣網站</p>
                      <p className="font-bold text-[#1a3a2e] group-hover:text-[#d4af37] transition-colors whitespace-nowrap">app.twgtart.cn</p>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* 為什麼信賴我們 */}
          <div className="bg-gradient-to-br from-[#1a3a2e] to-[#2d5a47] rounded-3xl p-10 relative overflow-hidden">
            <div className="absolute inset-0 opacity-10 pointer-events-none">
              <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[700px] h-[700px] border border-[#d4af37] rounded-full"></div>
            </div>
            <div className="relative z-10">
              <div className="text-center mb-10">
                <h4 className="text-3xl font-bold text-white mb-2">為什麼全球藏家都信賴我們？</h4>
                <p className="text-[#d4af37] text-lg">專業 · 誠信 · 高效 · 隱私</p>
              </div>
              <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
                {[
                  { icon: 'ri-shield-star-line', title: '國際級鑑定天團把關', desc: '資深專家團隊，精準甄別真偽，確保每件拍品品質' },
                  { icon: 'ri-map-2-line', title: '台灣＋大陸雙地服務', desc: '台北、福州雙據點，兩岸藏家皆可就近送拍諮詢' },
                  { icon: 'ri-trophy-line', title: '超高成交率紀錄', desc: '多年累計億元成交，每場拍賣會均創佳績' },
                  { icon: 'ri-lock-password-line', title: '1v1 隱私專屬服務', desc: '全程保密，一對一專屬顧問，讓您安心委託' },
                ].map((item, i) => (
                  <div key={i} className="bg-white/10 backdrop-blur-sm border border-[#d4af37]/30 rounded-2xl p-6 hover:bg-white/15 hover:border-[#d4af37]/60 transition-all">
                    <div className="w-12 h-12 bg-[#d4af37]/20 rounded-full flex items-center justify-center mb-4">
                      <i className={`${item.icon} text-[#d4af37] text-2xl`}></i>
                    </div>
                    <h5 className="text-white font-bold text-base mb-2 leading-snug">{item.title}</h5>
                    <p className="text-white/65 text-sm leading-relaxed">{item.desc}</p>
                  </div>
                ))}
              </div>

              {/* 底部 CTA */}
              <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
                <button
                  onClick={() => scrollToSection('free-appraisal-form')}
                  className="bg-[#d4af37] text-[#1a3a2e] px-10 py-4 rounded-full text-lg font-bold hover:bg-[#c19b2e] transition-all hover:scale-105 cursor-pointer whitespace-nowrap flex items-center gap-3"
                >
                  <i className="ri-send-plane-fill text-xl"></i>
                  立即免費送拍評估
                </button>
                <button
                  onClick={() => setShowBookingModal(true)}
                  className="bg-white/10 border-2 border-[#d4af37] text-white px-10 py-4 rounded-full text-lg font-semibold hover:bg-[#d4af37]/20 transition-all hover:scale-105 cursor-pointer whitespace-nowrap flex items-center gap-3"
                >
                  <i className="ri-calendar-check-line text-xl"></i>
                  線上預約送拍
                </button>
                <a
                  href="tel:0916661789"
                  className="border-2 border-[#d4af37] text-white px-10 py-4 rounded-full text-lg font-semibold hover:bg-[#d4af37]/20 transition-all hover:scale-105 cursor-pointer whitespace-nowrap flex items-center gap-3"
                >
                  <i className="ri-phone-line text-xl"></i>
                  電話諮詢 0916-661789
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 關於林偉昌 */}
      <section id="about" className="py-20 bg-gradient-to-b from-white to-[#f5f5f0]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-16 items-center">
            <div className="relative">
              <div className="inline-block bg-[#d4af37] text-white px-4 py-1 rounded-full text-sm mb-6 whitespace-nowrap">關於光特藝術拍賣</div>
              <div className="relative rounded-3xl overflow-hidden shadow-2xl">
                <img 
                  src="https://readdy.ai/api/search-image?query=Prestigious%20Chinese%20art%20auction%20house%20interior%20with%20elegant%20display%20of%20ancient%20paintings%20calligraphy%20porcelain%20jade%20sculptures%20and%20Western%20classic%20artworks%2C%20professional%20gallery%20lighting%20showcasing%20diverse%20art%20collections%20from%20ancient%20to%20modern%20periods%2C%20sophisticated%20auction%20hall%20with%20refined%20atmosphere%2C%20high-end%20art%20institution%20ambiance%20with%20warm%20golden%20tones&width=600&height=800&seq=about-auction-house-001&orientation=portrait"
                  alt="光特藝術拍賣"
                  className="w-full h-auto"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6">
                  <p className="text-white text-xl font-semibold">收購專線：0916-661789</p>
                </div>
              </div>
            </div>

            <div>
              <h2 className="text-4xl font-bold text-[#1a3a2e] mb-3 leading-tight">光特藝術拍賣</h2>
              <p className="text-xl text-[#d4af37] mb-6">深耕藝術品拍賣領域多年</p>
              
              <div className="space-y-6 text-gray-700 text-lg leading-relaxed">
                <p>
                  光特藝術拍賣深耕藝術品拍賣領域多年，專注於為藏家與藝術家提供<strong className="text-[#1a3a2e]">專業、全面的一站式服務</strong>。業務涵蓋古今中外各類藝術品，包括中國古代書畫、瓷器、玉器，近現代油畫、雕塑，以及西方經典藝術佳作。
                </p>
                <p>
                  憑藉<strong className="text-[#1a3a2e]">專業的鑒賞團隊</strong>，我們精準甄別藝術品真偽，評估其價值，確保每一件拍品的品質與市場潛力，讓每位藏家都能放心參與競標。
                </p>
                <p>
                  依托廣泛的客戶資源與高效的拍賣平台，我們致力於打造每一場<strong className="text-[#1a3a2e]">精彩紛呈的拍賣會</strong>，最大化藝術品的市場價值。無論是藏家尋覓心儀珍品，還是藝術家尋求作品展示機會，我們都提供貼心服務。
                </p>
              </div>

              {/* 四大業務亮點 */}
              <div className="grid grid-cols-2 gap-4 mt-8 mb-8">
                {[
                  { icon: 'ri-ancient-pavilion-line', label: '中國古代書畫', sub: '書畫 · 瓷器 · 玉器' },
                  { icon: 'ri-palette-line', label: '近現代藝術', sub: '油畫 · 雕塑 · 當代' },
                  { icon: 'ri-global-line', label: '西方經典藝術', sub: '歐洲名家佳作' },
                  { icon: 'ri-auction-line', label: '專業拍賣平台', sub: '透明 · 高效 · 安全' },
                ].map((item, i) => (
                  <div key={i} className="flex items-start gap-3 bg-[#f5f5f0] rounded-xl p-4 border border-[#f0ebe0]">
                    <div className="w-10 h-10 bg-[#d4af37]/20 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className={`${item.icon} text-[#d4af37] text-xl`}></i>
                    </div>
                    <div>
                      <p className="font-bold text-[#1a3a2e] text-sm">{item.label}</p>
                      <p className="text-gray-500 text-xs mt-0.5">{item.sub}</p>
                    </div>
                  </div>
                ))}
              </div>

              <a href="https://www.youtube.com/@光特藝術拍賣" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-[#1a3a2e] text-white px-8 py-4 rounded-xl font-semibold hover:bg-[#2d5a47] transition-all hover:scale-105 cursor-pointer whitespace-nowrap">
                <i className="ri-youtube-fill text-red-400 text-xl"></i>
                關注我們 · 獲取最新拍賣資訊
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* 四大收藏專區 */}
      <section className="py-20 bg-[#f5f5f0]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-[#1a3a2e] mb-2">服務項目</h2>
            <p className="text-gray-600">壽山石、字畫、珠寶天珠、佛像鑒賞交易</p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            {/* 壽山石專區 - 大卡片 */}
            <div className="md:row-span-2 relative rounded-2xl overflow-hidden shadow-xl group cursor-pointer" onClick={() => scrollToSection('shoushan')}>
              <div className="h-full min-h-[600px]">
                <img 
                  src="https://readdy.ai/api/search-image?query=Premium%20Shoushan%20stone%20collection%20display%2C%20featuring%20Tianhuang%2C%20Furong%20and%20Gaoshan%20varieties%20with%20vibrant%20red%2C%20golden%20and%20pink%20hues%2C%20arranged%20on%20dark%20wooden%20display%20stands%20against%20a%20deep%20emerald%20green%20silk%20backdrop%20with%20subtle%20Chinese%20traditional%20patterns%2C%20professional%20museum%20lighting%20emphasizing%20the%20stones%20natural%20translucency%20and%20intricate%20carvings%2C%20luxurious%20high-end%20atmosphere&width=800&height=1200&seq=shoushan-main-001&orientation=portrait"
                  alt="壽山石收購"
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                <div className="absolute bottom-0 left-0 p-8">
                  <h3 className="text-4xl font-bold text-white mb-3">壽山石收購</h3>
                  <p className="text-[#d4af37] text-lg mb-4">田黃 · 芙蓉 · 高山</p>
                  <div className="flex items-center text-white">
                    <span className="mr-2">了解更多</span>
                    <i className="ri-arrow-right-line text-[#d4af37]"></i>
                  </div>
                </div>
              </div>
            </div>

            {/* 字畫珠寶 */}
            <div className="relative rounded-2xl overflow-hidden shadow-xl group cursor-pointer" onClick={() => scrollToSection('calligraphy')}>
              <div className="h-[290px]">
                <img 
                  src="https://readdy.ai/api/search-image?query=Ancient%20Chinese%20calligraphy%20scroll%20and%20jade%20jewelry%20collection%2C%20featuring%20elegant%20ink%20paintings%20with%20red%20seal%20stamps%20and%20exquisite%20jade%20pendants%20with%20intricate%20carvings%2C%20displayed%20on%20dark%20teal%20silk%20fabric%20background%2C%20soft%20professional%20lighting%20highlighting%20the%20artwork%20details%20and%20jade%20translucency%2C%20refined%20traditional%20Chinese%20aesthetic&width=800&height=600&seq=calligraphy-jewelry-001&orientation=landscape"
                  alt="字畫珠寶"
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                <div className="absolute top-6 right-6 bg-[#d4af37] text-white px-4 py-1 rounded-full text-sm whitespace-nowrap">字畫珠寶</div>
                <div className="absolute bottom-6 left-6">
                  <p className="text-white text-lg">名家字畫 · 翡翠珠寶</p>
                </div>
              </div>
            </div>

            {/* 佛像天珠 */}
            <div className="relative rounded-2xl overflow-hidden shadow-xl group cursor-pointer" onClick={() => scrollToSection('buddha')}>
              <div className="h-[290px]">
                <img 
                  src="https://readdy.ai/api/search-image?query=Ancient%20Buddhist%20statues%20and%20Dzi%20beads%20collection%2C%20featuring%20golden%20bronze%20Buddha%20sculptures%20with%20serene%20expressions%20and%20rare%20Tibetan%20Dzi%20beads%20with%20distinctive%20eye%20patterns%2C%20arranged%20on%20deep%20burgundy%20silk%20backdrop%20with%20traditional%20Tibetan%20motifs%2C%20warm%20ambient%20lighting%20creating%20sacred%20atmosphere%2C%20museum%20quality%20presentation&width=800&height=600&seq=buddha-dzi-001&orientation=landscape"
                  alt="佛像天珠"
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                <div className="absolute top-6 right-6 bg-[#d4af37] text-white px-4 py-1 rounded-full text-sm whitespace-nowrap">佛像天珠</div>
                <div className="absolute bottom-6 left-6">
                  <p className="text-white text-lg">古董佛像 · 西藏天珠</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 鎮店之寶 */}
      <section className="py-20 bg-gradient-to-b from-[#0d1f17] to-[#1a3a2e] relative overflow-hidden">
        {/* 裝飾背景 */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] border border-[#d4af37] rounded-full"></div>
          <div className="absolute top-10 left-1/2 -translate-x-1/2 w-[600px] h-[600px] border border-[#d4af37] rounded-full"></div>
        </div>

        <div className="max-w-7xl mx-auto px-6 relative z-10">
          {/* 標題 */}
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-white" style={{ fontFamily: "'Noto Serif SC', serif" }}>
              鎮店之寶
            </h2>
          </div>

          {/* 主展示區 */}
          <div className="flex flex-col lg:flex-row items-center gap-16">
            {/* 圖片展示 */}
            <div className="lg:w-1/2 flex justify-center">
              <div className="relative">
                {/* 外層光暈 */}
                <div className="absolute -inset-8 bg-[#d4af37]/10 rounded-full blur-3xl"></div>
                {/* 金色邊框裝飾 */}
                <div className="absolute -inset-4 border-2 border-[#d4af37]/40 rounded-2xl rotate-3"></div>
                <div className="absolute -inset-4 border-2 border-[#d4af37]/20 rounded-2xl -rotate-3"></div>
                {/* 主圖 */}
                <div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-[#d4af37]/60" style={{ width: '460px', height: '520px' }}>
                  <img
                    src="https://static.readdy.ai/image/4f3f06d226654fda02a3ba64a379f0f2/b3efbcfc80dc549c6cea0173b5a48e77.jpeg"
                    alt="鎮店之寶 壽山石精品"
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                  {/* 角落裝飾 */}
                  <div className="absolute top-4 left-4 w-8 h-8 border-t-2 border-l-2 border-[#d4af37]"></div>
                  <div className="absolute top-4 right-4 w-8 h-8 border-t-2 border-r-2 border-[#d4af37]"></div>
                  <div className="absolute bottom-4 left-4 w-8 h-8 border-b-2 border-l-2 border-[#d4af37]"></div>
                  <div className="absolute bottom-4 right-4 w-8 h-8 border-b-2 border-r-2 border-[#d4af37]"></div>
                </div>
                {/* 印章標籤 */}
                <div className="absolute -bottom-5 left-1/2 -translate-x-1/2 bg-[#d4af37] text-[#1a3a2e] px-8 py-2 rounded-full font-bold text-lg shadow-xl whitespace-nowrap">
                  ✦ 奇苑藝術館 · 珍藏 ✦
                </div>
              </div>
            </div>

            {/* 文字介紹 */}
            <div className="lg:w-1/2 text-white">
              <div className="inline-block border border-[#d4af37]/60 text-[#d4af37] px-5 py-1 rounded-full text-sm tracking-widest mb-8 whitespace-nowrap">
                頂級壽山石雕件
              </div>

              <h3 className="text-4xl font-bold text-white mb-6 leading-snug" style={{ fontFamily: "'Noto Serif SC', serif" }}>
                壽山石龍騰雲海<br/>
                <span className="text-[#d4af37]">天下第一石</span>
              </h3>

              <div className="space-y-4 text-white/80 text-lg leading-relaxed mb-10">
                <p>
                  此件壽山石雕件色澤橙紅如火，質地溫潤細膩，為壽山石中之上品。石料天然渾成，雕工精湛，刀法流暢，龍紋栩栩如生，氣勢磅礴。
                </p>
                <p>
                  奇苑藝術館珍藏多年，乃鎮館之寶，見證了光特拍賣三十年的收藏歷程與深厚底蘊。此石集天地靈氣，為難得一見的頂級藏品。
                </p>
              </div>

              {/* 規格參數 */}
              <div className="grid grid-cols-2 gap-4 mb-10">
                {[
                  { label: '石種', value: '壽山石' },
                  { label: '品級', value: '頂級精品' },
                  { label: '工藝', value: '手工精雕' },
                  { label: '來源', value: '奇苑藝術館' },
                ].map((item, i) => (
                  <div key={i} className="border border-[#d4af37]/30 rounded-xl p-4 bg-white/5">
                    <p className="text-[#d4af37] text-sm mb-1 tracking-wider">{item.label}</p>
                    <p className="text-white font-semibold text-lg">{item.value}</p>
                  </div>
                ))}
              </div>

              <a
                href="tel:0916661789"
                className="inline-flex items-center gap-3 bg-[#d4af37] text-[#1a3a2e] px-10 py-4 rounded-full text-lg font-bold hover:bg-[#c19b2e] transition-all hover:scale-105 cursor-pointer whitespace-nowrap shadow-lg"
              >
                <i className="ri-phone-fill text-xl"></i>
                詢問此寶 · 0916-661789
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* 壽山石收購專區 */}
      <section id="shoushan" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-3 gap-8 mb-12">
            <div className="bg-gradient-to-br from-[#f5f5f0] to-white p-8 rounded-2xl shadow-lg">
              <div className="w-16 h-16 bg-[#d4af37] rounded-full flex items-center justify-center mb-6">
                <i className="ri-vip-crown-line text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-[#1a3a2e] mb-3">田黃石</h3>
              <p className="text-gray-600 leading-relaxed">石中之王，色澤金黃，質地溫潤，極具收藏價值</p>
            </div>

            <div className="bg-gradient-to-br from-[#f5f5f0] to-white p-8 rounded-2xl shadow-lg">
              <div className="w-16 h-16 bg-[#d4af37] rounded-full flex items-center justify-center mb-6">
                <i className="ri-gemstone-line text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-[#1a3a2e] mb-3">芙蓉石</h3>
              <p className="text-gray-600 leading-relaxed">色如芙蓉，質地細膩，溫潤如玉，深受藏家喜愛</p>
            </div>

            <div className="bg-gradient-to-br from-[#f5f5f0] to-white p-8 rounded-2xl shadow-lg">
              <div className="w-16 h-16 bg-[#d4af37] rounded-full flex items-center justify-center mb-6">
                <i className="ri-award-line text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-[#1a3a2e] mb-3">雞血石</h3>
              <p className="text-gray-600 leading-relaxed">色彩鮮豔如血，紋理獨特，品質上乘，極具藝術價值</p>
            </div>
          </div>

          <div className="grid md:grid-cols-4 gap-6">
            {[1, 2, 3, 4, 5, 6, 7, 8].map((item) => (
              <div key={item} className="group cursor-pointer">
                <div className="relative rounded-xl overflow-hidden shadow-lg mb-4">
                  <div className="w-full h-64">
                    <img 
                      src={`https://readdy.ai/api/search-image?query=Exquisite%20Shoushan%20stone%20carving%20masterpiece%20with%20vibrant%20red%20and%20golden%20colors%2C%20featuring%20intricate%20traditional%20Chinese%20motifs%20like%20dragons%20or%20phoenixes%2C%20displayed%20on%20dark%20wooden%20stand%20against%20simple%20gradient%20background%2C%20professional%20studio%20lighting%20highlighting%20the%20stones%20natural%20translucency%20and%20fine%20craftsmanship%20details%2C%20museum%20quality%20presentation&width=400&height=500&seq=shoushan-item-00${item}&orientation=portrait`}
                      alt={`壽山石精品 ${item}`}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                  </div>
                  <div className="absolute top-3 right-3 bg-[#d4af37] text-white px-3 py-1 rounded-full text-xs whitespace-nowrap">精品收藏</div>
                </div>
                <h4 className="text-lg font-semibold text-[#1a3a2e] mb-1">壽山石雕件</h4>
                <p className="text-gray-600 text-sm">專業鑒定 · 高價收購</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 字畫作品專區 */}
      <section id="calligraphy" className="py-20 bg-[#f5f5f0]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-3 gap-8">
            {[1, 2, 3, 4, 5, 6].map((item) => (
              <div key={item} className="bg-white rounded-2xl overflow-hidden shadow-xl group cursor-pointer">
                <div className="relative h-80">
                  <img 
                    src={`https://readdy.ai/api/search-image?query=Traditional%20Chinese%20calligraphy%20and%20painting%20masterpiece%2C%20featuring%20elegant%20ink%20brush%20strokes%20with%20classical%20poetry%20or%20landscape%20painting%2C%20mounted%20on%20aged%20silk%20scroll%20with%20red%20seal%20stamps%2C%20displayed%20against%20neutral%20beige%20background%2C%20soft%20museum%20lighting%20emphasizing%20the%20artworks%20texture%20and%20historical%20patina%2C%20refined%20scholarly%20aesthetic&width=600&height=800&seq=calligraphy-work-00${item}&orientation=portrait`}
                    alt={`字畫作品 ${item}`}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </div>
                <div className="p-6">
                  <h4 className="text-xl font-bold text-[#1a3a2e] mb-2">名家書畫作品</h4>
                  <p className="text-gray-600">真跡保證 · 專業鑒定 · 收藏投資</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 珠寶與天珠專區 */}
      <section id="jewelry" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-12 mb-16">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl group cursor-pointer">
              <div className="h-96">
                <img 
                  src="https://readdy.ai/api/search-image?query=Exquisite%20jade%20and%20gemstone%20jewelry%20collection%2C%20featuring%20translucent%20emerald%20green%20jade%20bangles%2C%20pendants%20and%20rings%20with%20intricate%20gold%20settings%2C%20arranged%20on%20dark%20velvet%20fabric%20background%2C%20professional%20jewelry%20photography%20lighting%20highlighting%20the%20jades%20natural%20translucency%20and%20vibrant%20color%2C%20luxurious%20high-end%20presentation&width=800&height=600&seq=jade-jewelry-main-001&orientation=landscape"
                  alt="翡翠珠寶"
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
                <div className="absolute bottom-8 left-8">
                  <h3 className="text-3xl font-bold text-white mb-2">翡翠珠寶</h3>
                  <p className="text-[#d4af37] text-lg">冰種翡翠 · 和田玉 · 寶石</p>
                </div>
              </div>
            </div>

            <div className="relative rounded-2xl overflow-hidden shadow-2xl group cursor-pointer">
              <div className="h-96">
                <img 
                  src="https://readdy.ai/api/search-image?query=Rare%20Tibetan%20Dzi%20beads%20collection%2C%20featuring%20ancient%20agate%20beads%20with%20distinctive%20eye%20patterns%20and%20natural%20weathering%20marks%2C%20arranged%20on%20traditional%20Tibetan%20silk%20brocade%20fabric%20with%20Buddhist%20motifs%2C%20warm%20ambient%20lighting%20emphasizing%20the%20beads%20sacred%20mystique%20and%20historical%20significance%2C%20spiritual%20and%20reverent%20atmosphere&width=800&height=600&seq=dzi-beads-main-001&orientation=landscape"
                  alt="西藏天珠"
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
                <div className="absolute bottom-8 left-8">
                  <h3 className="text-3xl font-bold text-white mb-2">西藏天珠</h3>
                  <p className="text-[#d4af37] text-lg">九眼天珠 · 至純天珠 · 老天珠</p>
                </div>
              </div>
            </div>
          </div>

          <div className="grid md:grid-cols-4 gap-6">
            {[1, 2, 3, 4, 5, 6, 7, 8].map((item) => (
              <div key={item} className="group cursor-pointer">
                <div className="relative rounded-xl overflow-hidden shadow-lg mb-4">
                  <div className="w-full h-64">
                    <img 
                      src={`https://readdy.ai/api/search-image?query=Premium%20jade%20jewelry%20or%20Tibetan%20Dzi%20bead%20close-up%2C%20featuring%20vibrant%20emerald%20green%20jade%20with%20natural%20translucency%20or%20ancient%20agate%20bead%20with%20eye%20patterns%2C%20displayed%20on%20dark%20silk%20fabric%20background%2C%20professional%20macro%20photography%20with%20soft%20lighting%20highlighting%20intricate%20details%20and%20natural%20beauty%2C%20elegant%20minimalist%20composition&width=400&height=500&seq=jewelry-item-00${item}&orientation=portrait`}
                      alt={`珠寶天珠 ${item}`}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                  </div>
                </div>
                <h4 className="text-lg font-semibold text-[#1a3a2e] mb-1">精品珠寶</h4>
                <p className="text-gray-600 text-sm">真品保證 · 專業鑒定</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 佛像藝術專區 */}
      <section id="buddha" className="py-20 bg-[#f5f5f0]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-3 gap-8">
            {[1, 2, 3, 4, 5, 6].map((item) => (
              <div key={item} className="bg-white rounded-2xl overflow-hidden shadow-xl group cursor-pointer">
                <div className="relative h-96">
                  <img 
                    src={`https://readdy.ai/api/search-image?query=Ancient%20Buddhist%20statue%20masterpiece%2C%20featuring%20golden%20bronze%20Buddha%20sculpture%20with%20serene%20expression%20and%20intricate%20details%2C%20traditional%20Chinese%20or%20Tibetan%20style%20with%20ornate%20robes%20and%20mudra%20hand%20gestures%2C%20displayed%20against%20dark%20gradient%20background%20with%20subtle%20sacred%20atmosphere%2C%20warm%20professional%20lighting%20emphasizing%20the%20statues%20craftsmanship%20and%20spiritual%20presence&width=600&height=900&seq=buddha-statue-00${item}&orientation=portrait`}
                    alt={`佛像藝術 ${item}`}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </div>
                <div className="p-6">
                  <h4 className="text-xl font-bold text-[#1a3a2e] mb-2">古董佛像珍品</h4>
                  <p className="text-gray-600">明清時期 · 藏傳佛教 · 藝術收藏</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 直播拍賣功能區 */}
      <section className="py-20 bg-gradient-to-br from-[#1a3a2e] to-[#2d5a47] relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-10 left-10 w-64 h-64 border border-[#d4af37] rounded-full"></div>
          <div className="absolute bottom-10 right-10 w-96 h-96 border border-[#d4af37] rounded-full"></div>
        </div>

        <div className="max-w-7xl mx-auto px-6 relative z-10">
          <div className="grid md:grid-cols-2 gap-16 items-center">
            <div>
              <div className="text-[#d4af37] text-xs font-semibold mb-3 tracking-widest whitespace-nowrap">LIVE AUCTION</div>
              <h2 className="text-4xl font-bold text-white mb-3 leading-tight">即時直播拍賣</h2>
              <p className="text-lg text-white/80 mb-8">每週三場 · 線上競標 · 即時成交</p>
              
              <div className="space-y-4 mb-10">
                <div className="flex items-center text-white text-lg">
                  <i className="ri-checkbox-circle-fill text-[#d4af37] text-2xl mr-3"></i>
                  <span>專業鑒定團隊</span>
                </div>
                <div className="flex items-center text-white text-lg">
                  <i className="ri-checkbox-circle-fill text-[#d4af37] text-2xl mr-3"></i>
                  <span>保真承諾</span>
                </div>
                <div className="flex items-center text-white text-lg">
                  <i className="ri-checkbox-circle-fill text-[#d4af37] text-2xl mr-3"></i>
                  <span>全程直播透明</span>
                </div>
              </div>

              <div className="flex flex-wrap gap-4">
                <a href="tel:0916661789" className="inline-block bg-[#d4af37] text-[#1a3a2e] px-10 py-4 rounded-full text-lg font-semibold hover:bg-[#c19b2e] transition-all hover:scale-105 cursor-pointer whitespace-nowrap">
                  聯繫參與直播
                </a>
                <a href="https://www.youtube.com/@光特藝術拍賣" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 border-2 border-red-500 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-red-500/20 transition-all hover:scale-105 cursor-pointer whitespace-nowrap">
                  <i className="ri-youtube-fill text-red-400 text-xl"></i>
                  YouTube 頻道
                </a>
              </div>
            </div>

            <div className="relative">
              <div className="rounded-2xl overflow-hidden border-4 border-[#d4af37] shadow-2xl">
                <img 
                  src="https://readdy.ai/api/search-image?query=Professional%20Chinese%20antique%20live%20auction%20scene%2C%20featuring%20auctioneer%20presenting%20exquisite%20Shoushan%20stone%20or%20jade%20artifact%20on%20elegant%20display%20stand%2C%20modern%20auction%20house%20interior%20with%20professional%20lighting%20and%20cameras%2C%20audience%20members%20viewing%20through%20screens%2C%20dynamic%20and%20engaging%20atmosphere%2C%20high-end%20professional%20broadcast%20quality&width=900&height=600&seq=live-auction-scene-001&orientation=landscape"
                  alt="直播拍賣"
                  className="w-full h-auto"
                />
              </div>
              <div className="absolute -bottom-6 -right-6 bg-white p-6 rounded-xl shadow-xl">
                <p className="text-sm text-gray-600 mb-1 whitespace-nowrap">下次直播時間</p>
                <p className="text-2xl font-bold text-[#1a3a2e] whitespace-nowrap">每週六 20:00</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 成功案例專區 */}
      <section id="success-cases" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          {/* 統計數字 */}
          <div className="grid grid-cols-4 gap-6 mb-16">
            {[
              { value: '3,000+', label: '成功鑑定件數', icon: 'ri-search-eye-line' },
              { value: '30年', label: '專業從業經驗', icon: 'ri-time-line' },
              { value: '98%', label: '客戶滿意度', icon: 'ri-emotion-happy-line' },
              { value: '億元+', label: '累計成交金額', icon: 'ri-money-cny-circle-line' },
            ].map((stat, i) => (
              <div key={i} className="text-center bg-gradient-to-br from-[#f5f5f0] to-white rounded-2xl p-8 shadow-md border border-[#f0ebe0]">
                <div className="w-14 h-14 bg-[#d4af37]/15 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${stat.icon} text-[#d4af37] text-2xl`}></i>
                </div>
                <p className="text-4xl font-bold text-[#1a3a2e] mb-2">{stat.value}</p>
                <p className="text-gray-500 text-sm">{stat.label}</p>
              </div>
            ))}
          </div>

          {/* 案例卡片 */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
            {[
              {
                category: '壽山石',
                categoryColor: 'bg-amber-500',
                title: '清代田黃石獸鈕印章',
                desc: '藏家委託鑑定一枚家傳印章，經林先生鑑定確認為清代田黃石，色澤金黃純正，質地溫潤細膩，底部篆刻「福壽」二字，工藝精湛。',
                result: '成功收購',
                price: 'NT$ 2,800,000',
                date: '2024年11月',
                tags: ['田黃石', '清代', '印章'],
                image: 'https://readdy.ai/api/search-image?query=Antique%20Qing%20dynasty%20Tianhuang%20stone%20seal%20with%20golden%20yellow%20color%2C%20carved%20beast%20knob%20on%20top%2C%20red%20seal%20paste%20marks%20on%20bottom%20with%20Chinese%20characters%2C%20displayed%20on%20dark%20wooden%20stand%20with%20professional%20museum%20lighting%2C%20close-up%20detail%20showing%20natural%20grain%20and%20translucency%2C%20prestigious%20collectible&width=600&height=500&seq=case-tianhuang-seal-001&orientation=landscape'
              },
              {
                category: '字畫',
                categoryColor: 'bg-emerald-600',
                title: '齊白石山水花鳥冊頁',
                desc: '客戶持有一批祖傳字畫，經林先生逐一鑑定，其中一冊確認為近代大師齊白石真跡，筆墨蒼勁，印章清晰，附有出版著錄記載。',
                result: '成功拍賣',
                price: 'NT$ 5,200,000',
                date: '2024年9月',
                tags: ['齊白石', '近代名家', '冊頁'],
                image: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20ink%20painting%20album%20pages%20by%20famous%20master%2C%20featuring%20delicate%20bird%20and%20flower%20motifs%20with%20mountains%2C%20elegant%20brushwork%20with%20red%20seal%20stamps%2C%20aged%20silk%20mounting%20with%20natural%20patina%2C%20displayed%20on%20neutral%20background%20with%20soft%20scholarly%20lighting%2C%20museum%20quality%20artwork&width=600&height=500&seq=case-qibaishi-painting-001&orientation=landscape'
              },
              {
                category: '天珠',
                categoryColor: 'bg-rose-600',
                title: '西藏古代九眼天珠',
                desc: '藏家持有一顆家傳天珠，經林先生鑑定確認為西藏古代九眼天珠，眼紋清晰完整，包漿自然，年代久遠，為天珠中之極品。',
                result: '成功收購',
                price: 'NT$ 3,600,000',
                date: '2024年8月',
                tags: ['九眼天珠', '西藏古代', '極品'],
                image: 'https://readdy.ai/api/search-image?query=Ancient%20Tibetan%20nine-eye%20Dzi%20bead%20with%20distinctive%20eye%20patterns%20and%20natural%20weathering%2C%20deep%20brown%20agate%20with%20white%20eye%20markings%2C%20sacred%20Buddhist%20artifact%20with%20natural%20patina%20showing%20age%2C%20displayed%20on%20dark%20silk%20fabric%20with%20warm%20ambient%20lighting%20emphasizing%20mystical%20quality%2C%20rare%20collectible&width=600&height=500&seq=case-dzi-nine-eye-001&orientation=landscape'
              },
              {
                category: '壽山石',
                categoryColor: 'bg-amber-500',
                title: '民國芙蓉石雕山水擺件',
                desc: '客戶委託鑑定一件壽山石擺件，林先生鑑定為民國時期芙蓉石精品，粉色細膩均勻，雕工精湛，山水人物栩栩如生，保存完好。',
                result: '直播拍賣成交',
                price: 'NT$ 980,000',
                date: '2024年7月',
                tags: ['芙蓉石', '民國', '山水雕件'],
                image: 'https://readdy.ai/api/search-image?query=Republic%20of%20China%20era%20Furong%20Shoushan%20stone%20landscape%20carving%2C%20delicate%20pink%20stone%20with%20intricate%20mountain%20and%20figure%20scenes%2C%20fine%20craftsmanship%20showing%20traditional%20Chinese%20scenery%2C%20displayed%20on%20dark%20wooden%20stand%20against%20gradient%20background%2C%20professional%20lighting%20highlighting%20pink%20translucency%20and%20carved%20details&width=600&height=500&seq=case-furong-landscape-001&orientation=landscape'
              },
              {
                category: '佛像',
                categoryColor: 'bg-yellow-600',
                title: '明代銅鎏金觀音菩薩像',
                desc: '藏家持有一尊銅像，經林先生鑑定確認為明代銅鎏金觀音菩薩像，造型莊嚴，鎏金保存良好，底部有梵文銘文，為難得一見的宗教藝術珍品。',
                result: '成功收購',
                price: 'NT$ 4,500,000',
                date: '2024年6月',
                tags: ['明代', '銅鎏金', '觀音菩薩'],
                image: 'https://readdy.ai/api/search-image?query=Ming%20dynasty%20gilt%20bronze%20Guanyin%20Bodhisattva%20statue%20with%20serene%20expression%2C%20golden%20surface%20with%20fine%20details%20of%20robes%20and%20jewelry%2C%20Sanskrit%20inscription%20on%20base%2C%20displayed%20against%20dark%20background%20with%20dramatic%20lighting%20emphasizing%20the%20golden%20surface%20and%20spiritual%20presence%2C%20museum%20quality%20religious%20artifact&width=600&height=500&seq=case-ming-guanyin-001&orientation=landscape'
              },
              {
                category: '珠寶',
                categoryColor: 'bg-teal-600',
                title: '清代翡翠冰種手鐲一對',
                desc: '客戶持有一對家傳翡翠手鐲，林先生鑑定確認為清代冰種翡翠，色澤翠綠均勻，透明度極高，無裂無綹，成對保存完整，極為珍貴。',
                result: '直播拍賣成交',
                price: 'NT$ 6,800,000',
                date: '2024年5月',
                tags: ['冰種翡翠', '清代', '手鐲'],
                image: 'https://readdy.ai/api/search-image?query=Pair%20of%20Qing%20dynasty%20ice-type%20jadeite%20bangles%20with%20vibrant%20emerald%20green%20color%20and%20exceptional%20translucency%2C%20matching%20pair%20displayed%20on%20dark%20velvet%20stand%2C%20professional%20jewelry%20lighting%20highlighting%20the%20natural%20green%20color%20and%20glass-like%20clarity%2C%20no%20cracks%20or%20inclusions%20visible%2C%20prestigious%20antique%20jewelry&width=600&height=500&seq=case-qing-jade-bangles-001&orientation=landscape'
              },
            ].map((item, index) => (
              <div key={index} className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 group border border-[#f0ebe0] hover:border-[#d4af37]/40">
                {/* 圖片 */}
                <div className="relative h-52 overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                  <div className="absolute top-4 left-4 flex gap-2">
                    <span className={`${item.categoryColor} text-white text-xs font-bold px-3 py-1 rounded-full whitespace-nowrap`}>{item.category}</span>
                  </div>
                  <div className="absolute bottom-4 right-4 bg-[#d4af37] text-[#1a3a2e] text-xs font-bold px-3 py-1 rounded-full whitespace-nowrap">
                    {item.result}
                  </div>
                </div>

                {/* 內容 */}
                <div className="p-6">
                  <h3 className="text-lg font-bold text-[#1a3a2e] mb-3 leading-snug">{item.title}</h3>
                  <p className="text-gray-600 text-sm leading-relaxed mb-4 line-clamp-3">{item.desc}</p>

                  {/* 標籤 */}
                  <div className="flex flex-wrap gap-2 mb-4">
                    {item.tags.map((tag, ti) => (
                      <span key={ti} className="bg-[#f5f5f0] text-[#1a3a2e] text-xs px-3 py-1 rounded-full border border-[#e8e0d0] whitespace-nowrap">{tag}</span>
                    ))}
                  </div>

                  {/* 成交資訊 */}
                  <div className="border-t border-[#f0ebe0] pt-4 flex items-center justify-between">
                    <div>
                      <p className="text-xs text-gray-400 mb-1">成交價格</p>
                      <p className="text-xl font-bold text-[#d4af37]">{item.price}</p>
                    </div>
                    <div className="text-right">
                      <p className="text-xs text-gray-400 mb-1">成交時間</p>
                      <p className="text-sm font-semibold text-[#1a3a2e]">{item.date}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* 底部 CTA */}
          <div className="text-center bg-gradient-to-br from-[#1a3a2e] to-[#2d5a47] rounded-3xl p-12 relative overflow-hidden">
            <div className="absolute inset-0 opacity-10">
              <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] border border-[#d4af37] rounded-full"></div>
              <div className="absolute top-10 left-1/2 -translate-x-1/2 w-[600px] h-[600px] border border-[#d4af37] rounded-full"></div>
            </div>
            <div className="relative z-10">
              <i className="ri-auction-line text-[#d4af37] text-5xl mb-4 block"></i>
              <h3 className="text-3xl font-bold text-white mb-3">您的藏品也可能是下一個成功案例</h3>
              <p className="text-white/70 text-lg mb-8">免費鑑定，無需付費，三十年專業經驗為您服務</p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                <button
                  onClick={() => scrollToSection('free-appraisal-form')}
                  className="bg-[#d4af37] text-[#1a3a2e] px-10 py-4 rounded-full text-lg font-bold hover:bg-[#c19b2e] transition-all hover:scale-105 cursor-pointer whitespace-nowrap flex items-center gap-3"
                >
                  <i className="ri-search-eye-line text-xl"></i>
                  立即申請免費鑑價
                </button>
                <a
                  href="tel:0916661789"
                  className="border-2 border-[#d4af37] text-white px-10 py-4 rounded-full text-lg font-semibold hover:bg-[#d4af37]/20 transition-all hover:scale-105 cursor-pointer whitespace-nowrap flex items-center gap-3"
                >
                  <i className="ri-phone-line text-xl"></i>
                  電話諮詢 0916-661789
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 藏品類型指南專區 */}
      <section className="py-20 bg-gradient-to-b from-white to-[#f5f5f0]">
        <div className="max-w-7xl mx-auto px-6">
          {/* 標題 */}
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-[#1a3a2e] mb-2">藏品類型指南</h2>
            <p className="text-gray-600">專業鑑定要點 · 真偽辨別技巧 · 收藏價值說明</p>
          </div>

          {/* Tab 切換按鈕 */}
          <div className="flex justify-center mb-12">
            <div className="inline-flex bg-white rounded-full p-2 shadow-lg border border-[#f0ebe0]">
              <button
                onClick={() => setActiveGuideTab('shoushan')}
                className={`px-8 py-3 rounded-full font-semibold transition-all cursor-pointer whitespace-nowrap ${
                  activeGuideTab === 'shoushan'
                    ? 'bg-[#d4af37] text-[#1a3a2e]'
                    : 'text-gray-600 hover:text-[#1a3a2e]'
                }`}
              >
                壽山石
              </button>
              <button
                onClick={() => setActiveGuideTab('dzi')}
                className={`px-8 py-3 rounded-full font-semibold transition-all cursor-pointer whitespace-nowrap ${
                  activeGuideTab === 'dzi'
                    ? 'bg-[#d4af37] text-[#1a3a2e]'
                    : 'text-gray-600 hover:text-[#1a3a2e]'
                }`}
              >
                天珠
              </button>
              <button
                onClick={() => setActiveGuideTab('buddha')}
                className={`px-8 py-3 rounded-full font-semibold transition-all cursor-pointer whitespace-nowrap ${
                  activeGuideTab === 'buddha'
                    ? 'bg-[#d4af37] text-[#1a3a2e]'
                    : 'text-gray-600 hover:text-[#1a3a2e]'
                }`}
              >
                佛像
              </button>
            </div>
          </div>

          {/* 壽山石指南 */}
          {activeGuideTab === 'shoushan' && (
            <div className="grid md:grid-cols-3 gap-8 mb-12">
              {/* 田黃石 */}
              <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-[#f0ebe0] hover:shadow-xl transition-shadow">
                <div className="relative h-64">
                  <img
                    src="https://readdy.ai/api/search-image?query=Premium%20Tianhuang%20Shoushan%20stone%20with%20golden%20yellow%20color%20and%20natural%20translucency%2C%20close-up%20showing%20fine%20texture%20and%20natural%20grain%20patterns%2C%20displayed%20on%20dark%20wooden%20stand%20against%20simple%20gradient%20background%2C%20professional%20studio%20lighting%20emphasizing%20the%20stones%20warm%20golden%20hue%20and%20smooth%20surface%2C%20museum%20quality%20presentation&width=600&height=600&seq=guide-tianhuang-001&orientation=squarish"
                    alt="田黃石鑑定指南"
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                  <div className="absolute bottom-4 left-4">
                    <h3 className="text-2xl font-bold text-white mb-1">田黃石</h3>
                    <p className="text-[#d4af37] text-sm">石中之王</p>
                  </div>
                </div>

                <div className="p-6">
                  <h4 className="text-lg font-bold text-[#1a3a2e] mb-4 flex items-center gap-2">
                    <i className="ri-eye-line text-[#d4af37]"></i>
                    鑑定要點
                  </h4>
                  <ul className="space-y-3 mb-6">
                    <li className="flex items-start gap-2 text-gray-700 text-sm">
                      <i className="ri-checkbox-circle-fill text-[#d4af37] mt-0.5 flex-shrink-0"></i>
                      <span><strong>色澤：</strong>金黃色至橙黃色，色澤純正均勻，溫潤如玉</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-700 text-sm">
                      <i className="ri-checkbox-circle-fill text-[#d4af37] mt-0.5 flex-shrink-0"></i>
                      <span><strong>質地：</strong>細膩溫潤，半透明至微透明，有油脂光澤</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-700 text-sm">
                      <i className="ri-checkbox-circle-fill text-[#d4af37] mt-0.5 flex-shrink-0"></i>
                      <span><strong>紋理：</strong>具有獨特的蘿蔔紋或格紋，自然流暢</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-700 text-sm">
                      <i className="ri-checkbox-circle-fill text-[#d4af37] mt-0.5 flex-shrink-0"></i>
                      <span><strong>石皮：</strong>表面常有黃色或黑色石皮，自然過渡</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-700 text-sm">
                      <i className="ri-checkbox-circle-fill text-[#d4af37] mt-0.5 flex-shrink-0"></i>
                      <span><strong>手感：</strong>溫潤細膩，有明顯的油脂感</span>
                    </li>
                  </ul>

                  <div className="border-t border-[#f0ebe0] pt-4 mb-4">
                    <h5 className="font-bold text-[#1a3a2e] mb-2 text-sm">真偽辨別</h5>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      真品田黃石色澤自然，紋理流暢，質地溫潤。假冒品多為染色或樹脂仿製，色澤不自然，無蘿蔔紋，手感較輕。
                    </p>
                  </div>

                  <div className="bg-[#f5f5f0] rounded-xl p-4">
                    <h5 className="font-bold text-[#1a3a2e] mb-2 text-sm flex items-center gap-2">
                      <i className="ri-star-fill text-[#d4af37]"></i>
                      收藏價值
                    </h5>
                    <p className="text-gray-700 text-sm leading-relaxed">
                      田黃石產量稀少，被譽為「石中之王」，歷來為皇室貴族珍藏，市場價值極高，是壽山石中的頂級品種。
                    </p>
                  </div>
                </div>
              </div>

              {/* 芙蓉石 */}
              <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-[#f0ebe0] hover:shadow-xl transition-shadow">
                <div className="relative h-64">
                  <img
                    src="https://readdy.ai/api/search-image?query=Premium%20Furong%20Shoushan%20stone%20with%20delicate%20pink%20color%20and%20fine%20texture%2C%20close-up%20showing%20smooth%20surface%20and%20natural%20translucency%2C%20displayed%20on%20dark%20wooden%20stand%20against%20simple%20gradient%20background%2C%20soft%20professional%20lighting%20emphasizing%20the%20stones%20gentle%20pink%20hue%20and%20refined%20quality%2C%20elegant%20presentation&width=600&height=600&seq=guide-furong-001&orientation=squarish"
                    alt="芙蓉石鑑定指南"
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                  <div className="absolute bottom-4 left-4">
                    <h3 className="text-2xl font-bold text-white mb-1">芙蓉石</h3>
                    <p className="text-[#d4af37] text-sm">溫潤如玉</p>
                  </div>
                </div>

                <div className="p-6">
                  <h4 className="text-lg font-bold text-[#1a3a2e] mb-4 flex items-center gap-2">
                    <i className="ri-eye-line text-[#d4af37]"></i>
                    鑑定要點
                  </h4>
                  <ul className="space-y-3 mb-6">
                    <li className="flex items-start gap-2 text-gray-700 text-sm">
                      <i className="ri-checkbox-circle-fill text-[#d4af37] mt-0.5 flex-shrink-0"></i>
                      <span><strong>色澤：</strong>粉紅色至淡紫色，色調柔和均勻</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-700 text-sm">
                      <i className="ri-checkbox-circle-fill text-[#d4af37] mt-0.5 flex-shrink-0"></i>
                      <span><strong>質地：</strong>細膩溫潤，半透明，質感如凝脂</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-700 text-sm">
                      <i className="ri-checkbox-circle-fill text-[#d4af37] mt-0.5 flex-shrink-0"></i>
                      <span><strong>紋理：</strong>紋理細膩，少有雜質，純淨度高</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-700 text-sm">
                      <i className="ri-checkbox-circle-fill text-[#d4af37] mt-0.5 flex-shrink-0"></i>
                      <span><strong>光澤：</strong>柔和的珍珠光澤，不刺眼</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-700 text-sm">
                      <i className="ri-checkbox-circle-fill text-[#d4af37] mt-0.5 flex-shrink-0"></i>
                      <span><strong>透明度：</strong>半透明至微透明，光線可透過</span>
                    </li>
                  </ul>

                  <div className="border-t border-[#f0ebe0] pt-4 mb-4">
                    <h5 className="font-bold text-[#1a3a2e] mb-2 text-sm">真偽辨別</h5>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      真品芙蓉石色澤柔和自然，質地細膩溫潤。仿品多為染色石料，色澤過於鮮豔，質地粗糙，缺乏天然的溫潤感。
                    </p>
                  </div>

                  <div className="bg-[#f5f5f0] rounded-xl p-4">
                    <h5 className="font-bold text-[#1a3a2e] mb-2 text-sm flex items-center gap-2">
                      <i className="ri-star-fill text-[#d4af37]"></i>
                      收藏價值
                    </h5>
                    <p className="text-gray-700 text-sm leading-relaxed">
                      芙蓉石質地細膩，色澤優雅，深受文人雅士喜愛，是壽山石中的上品，適合雕刻印章和擺件，收藏價值穩定。
                    </p>
                  </div>
                </div>
              </div>

              {/* 雞血石 */}
              <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-[#f0ebe0] hover:shadow-xl transition-shadow">
                <div className="relative h-64">
                  <img
                    src="https://readdy.ai/api/search-image?query=Premium%20Jiuxue%20Chicken%20Blood%20Stone%20with%20vibrant%20red%20patterns%20on%20white%20or%20grey%20base%2C%20close-up%20showing%20rich%20red%20cinnabar%20inclusions%20and%20unique%20natural%20textures%2C%20displayed%20on%20dark%20wooden%20stand%20against%20simple%20gradient%20background%2C%20professional%20lighting%20highlighting%20the%20stones%20colorful%20beauty%20and%20natural%20patterns%2C%20artistic%20presentation&width=600&height=600&seq=guide-jiuxue-001&orientation=squarish"
                    alt="雞血石鑑定指南"
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                  <div className="absolute bottom-4 left-4">
                    <h3 className="text-2xl font-bold text-white mb-1">雞血石</h3>
                    <p className="text-[#d4af37] text-sm">色彩鮮豔</p>
                  </div>
                </div>

                <div className="p-6">
                  <h4 className="text-lg font-bold text-[#1a3a2e] mb-4 flex items-center gap-2">
                    <i className="ri-eye-line text-[#d4af37]"></i>
                    鑑定要點
                  </h4>
                  <ul className="space-y-3 mb-6">
                    <li className="flex items-start gap-2 text-gray-700 text-sm">
                      <i className="ri-checkbox-circle-fill text-[#d4af37] mt-0.5 flex-shrink-0"></i>
                      <span><strong>色澤：</strong>鮮紅如雞血，色彩濃郁鮮豔，分佈自然</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-700 text-sm">
                      <i className="ri-checkbox-circle-fill text-[#d4af37] mt-0.5 flex-shrink-0"></i>
                      <span><strong>質地：</strong>地子細膩溫潤，多為白色或灰色底</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-700 text-sm">
                      <i className="ri-checkbox-circle-fill text-[#d4af37] mt-0.5 flex-shrink-0"></i>
                      <span><strong>血色：</strong>辰砂含量豐富，血色鮮豔且分佈均勻</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-700 text-sm">
                      <i className="ri-checkbox-circle-fill text-[#d4af37] mt-0.5 flex-shrink-0"></i>
                      <span><strong>光澤：</strong>柔和的蠟狀光澤，溫潤自然</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-700 text-sm">
                      <i className="ri-checkbox-circle-fill text-[#d4af37] mt-0.5 flex-shrink-0"></i>
                      <span><strong>品種：</strong>包括昌化雞血石、巴林雞血石等</span>
                    </li>
                  </ul>

                  <div className="border-t border-[#f0ebe0] pt-4 mb-4">
                    <h5 className="font-bold text-[#1a3a2e] mb-2 text-sm">真偽辨別</h5>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      真品雞血石血色自然鮮豔，地子細膩溫潤。仿品多為染色或人工合成，血色呆板不自然，地子粗糙，缺乏天然石料的靈動感。
                    </p>
                  </div>

                  <div className="bg-[#f5f5f0] rounded-xl p-4">
                    <h5 className="font-bold text-[#1a3a2e] mb-2 text-sm flex items-center gap-2">
                      <i className="ri-star-fill text-[#d4af37]"></i>
                      收藏價值
                    </h5>
                    <p className="text-gray-700 text-sm leading-relaxed">
                      雞血石色彩鮮豔獨特，自古被視為吉祥之石，適合雕刻印章和擺件，血色豐富者收藏價值極高，是印石中的珍品。
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* 天珠指南 */}
          {activeGuideTab === 'dzi' && (
            <div className="grid md:grid-cols-2 gap-8 mb-12">
              {/* 九眼天珠 */}
              <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-[#f0ebe0] hover:shadow-xl transition-shadow">
                <div className="relative h-80">
                  <img
                    src="https://readdy.ai/api/search-image?query=Ancient%20Tibetan%20nine-eye%20Dzi%20bead%20with%20distinctive%20nine%20eye%20patterns%20clearly%20visible%2C%20deep%20brown%20agate%20with%20white%20eye%20markings%20showing%20natural%20weathering%20and%20patina%2C%20close-up%20macro%20photography%20highlighting%20intricate%20details%20and%20sacred%20mystique%2C%20displayed%20on%20traditional%20Tibetan%20silk%20fabric%2C%20warm%20ambient%20lighting%2C%20museum%20quality%20presentation&width=800&height=800&seq=guide-nine-eye-dzi-001&orientation=squarish"
                    alt="九眼天珠鑑定指南"
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
                  <div className="absolute bottom-6 left-6">
                    <h3 className="text-3xl font-bold text-white mb-2">九眼天珠</h3>
                    <p className="text-[#d4af37] text-lg">天珠之王</p>
                  </div>
                </div>

                <div className="p-6">
                  <h4 className="text-lg font-bold text-[#1a3a2e] mb-4 flex items-center gap-2">
                    <i className="ri-eye-line text-[#d4af37]"></i>
                    鑑定要點
                  </h4>
                  <ul className="space-y-3 mb-6">
                    <li className="flex items-start gap-2 text-gray-700 text-sm">
                      <i className="ri-checkbox-circle-fill text-[#d4af37] mt-0.5 flex-shrink-0"></i>
                      <span><strong>眼紋：</strong>九個眼紋清晰完整，排列對稱，紋路自然</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-700 text-sm">
                      <i className="ri-checkbox-circle-fill text-[#d4af37] mt-0.5 flex-shrink-0"></i>
                      <span><strong>材質：</strong>瑪瑙質地，質地堅硬，密度高</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-700 text-sm">
                      <i className="ri-checkbox-circle-fill text-[#d4af37] mt-0.5 flex-shrink-0"></i>
                      <span><strong>包漿：</strong>表面有自然風化痕跡和油潤包漿</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-700 text-sm">
                      <i className="ri-checkbox-circle-fill text-[#d4af37] mt-0.5 flex-shrink-0"></i>
                      <span><strong>色澤：</strong>深褐色或黑色底色，白色眼紋對比明顯</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-700 text-sm">
                      <i className="ri-checkbox-circle-fill text-[#d4af37] mt-0.5 flex-shrink-0"></i>
                      <span><strong>孔道：</strong>孔道內壁光滑，有使用痕跡</span>
                    </li>
                  </ul>

                  <div className="border-t border-[#f0ebe0] pt-4 mb-4">
                    <h5 className="font-bold text-[#1a3a2e] mb-2 text-sm">真偽辨別</h5>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      真品九眼天珠眼紋自然流暢，包漿溫潤，有明顯的風化紋和使用痕跡。新仿品眼紋呆板，表面過於光滑，缺乏歲月痕跡。
                    </p>
                  </div>

                  <div className="bg-[#f5f5f0] rounded-xl p-4">
                    <h5 className="font-bold text-[#1a3a2e] mb-2 text-sm flex items-center gap-2">
                      <i className="ri-star-fill text-[#d4af37]"></i>
                      收藏價值
                    </h5>
                    <p className="text-gray-700 text-sm leading-relaxed">
                      九眼天珠被譽為「天珠之王」，象徵圓滿與智慧，極為稀有珍貴，是藏傳佛教聖物，市場價值極高，頂級收藏品。
                    </p>
                  </div>
                </div>
              </div>

              {/* 老天珠 */}
              <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-[#f0ebe0] hover:shadow-xl transition-shadow">
                <div className="relative h-80">
                  <img
                    src="https://readdy.ai/api/search-image?query=Ancient%20old%20Tibetan%20Dzi%20bead%20with%20natural%20weathering%20and%20patina%20showing%20centuries%20of%20history%2C%20distinctive%20eye%20patterns%20with%20natural%20wear%20marks%2C%20deep%20agate%20material%20with%20rich%20brown%20color%20and%20white%20markings%2C%20close-up%20showing%20authentic%20aging%20characteristics%20and%20sacred%20mystique%2C%20displayed%20on%20traditional%20fabric%2C%20warm%20lighting%20emphasizing%20historical%20value&width=800&height=800&seq=guide-old-dzi-001&orientation=squarish"
                    alt="老天珠鑑定指南"
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
                  <div className="absolute bottom-6 left-6">
                    <h3 className="text-3xl font-bold text-white mb-2">老天珠</h3>
                    <p className="text-[#d4af37] text-lg">歲月見證</p>
                  </div>
                </div>

                <div className="p-6">
                  <h4 className="text-lg font-bold text-[#1a3a2e] mb-4 flex items-center gap-2">
                    <i className="ri-eye-line text-[#d4af37]"></i>
                    鑑定要點
                  </h4>
                  <ul className="space-y-3 mb-6">
                    <li className="flex items-start gap-2 text-gray-700 text-sm">
                      <i className="ri-checkbox-circle-fill text-[#d4af37] mt-0.5 flex-shrink-0"></i>
                      <span><strong>年代：</strong>至少百年以上歷史，有明顯風化痕跡</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-700 text-sm">
                      <i className="ri-checkbox-circle-fill text-[#d4af37] mt-0.5 flex-shrink-0"></i>
                      <span><strong>包漿：</strong>表面包漿厚重溫潤，自然形成</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-700 text-sm">
                      <i className="ri-checkbox-circle-fill text-[#d4af37] mt-0.5 flex-shrink-0"></i>
                      <span><strong>風化紋：</strong>表面有自然風化紋路，深淺不一</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-700 text-sm">
                      <i className="ri-checkbox-circle-fill text-[#d4af37] mt-0.5 flex-shrink-0"></i>
                      <span><strong>孔道：</strong>孔道磨損明顯，內壁光滑圓潤</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-700 text-sm">
                      <i className="ri-checkbox-circle-fill text-[#d4af37] mt-0.5 flex-shrink-0"></i>
                      <span><strong>紋路：</strong>眼紋或線紋自然，有歲月痕跡</span>
                    </li>
                  </ul>

                  <div className="border-t border-[#f0ebe0] pt-4 mb-4">
                    <h5 className="font-bold text-[#1a3a2e] mb-2 text-sm">真偽辨別</h5>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      真品老天珠包漿自然厚重，風化紋深淺不一，孔道磨損明顯。新仿品多用化學方法做舊，包漿不自然，風化紋呆板規律。
                    </p>
                  </div>

                  <div className="bg-[#f5f5f0] rounded-xl p-4">
                    <h5 className="font-bold text-[#1a3a2e] mb-2 text-sm flex items-center gap-2">
                      <i className="ri-star-fill text-[#d4af37]"></i>
                      收藏價值
                    </h5>
                    <p className="text-gray-700 text-sm leading-relaxed">
                      老天珠歷史悠久，承載著藏族文化與信仰，每一顆都是獨一無二的，具有極高的歷史價值和收藏價值，市場稀缺。
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* 佛像指南 */}
          {activeGuideTab === 'buddha' && (
            <div className="grid md:grid-cols-2 gap-8 mb-12">
              {/* 明清銅像 */}
              <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-[#f0ebe0] hover:shadow-xl transition-shadow">
                <div className="relative h-80">
                  <img
                    src="https://readdy.ai/api/search-image?query=Ming%20and%20Qing%20dynasty%20gilt%20bronze%20Buddha%20statue%20with%20serene%20expression%20and%20exquisite%20craftsmanship%2C%20golden%20surface%20showing%20fine%20details%20of%20robes%20and%20jewelry%2C%20traditional%20Chinese%20Buddhist%20sculpture%20with%20elegant%20proportions%20and%20mudra%20hand%20gestures%2C%20displayed%20against%20dark%20background%20with%20professional%20lighting%20emphasizing%20the%20golden%20patina%20and%20historical%20significance%2C%20museum%20quality%20antique&width=800&height=800&seq=guide-ming-qing-buddha-001&orientation=squarish"
                    alt="明清銅像鑑定指南"
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
                  <div className="absolute bottom-6 left-6">
                    <h3 className="text-3xl font-bold text-white mb-2">明清銅像</h3>
                    <p className="text-[#d4af37] text-lg">宮廷藝術</p>
                  </div>
                </div>

                <div className="p-6">
                  <h4 className="text-lg font-bold text-[#1a3a2e] mb-4 flex items-center gap-2">
                    <i className="ri-eye-line text-[#d4af37]"></i>
                    鑑定要點
                  </h4>
                  <ul className="space-y-3 mb-6">
                    <li className="flex items-start gap-2 text-gray-700 text-sm">
                      <i className="ri-checkbox-circle-fill text-[#d4af37] mt-0.5 flex-shrink-0"></i>
                      <span><strong>工藝：</strong>鑄造精細，線條流暢，比例協調</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-700 text-sm">
                      <i className="ri-checkbox-circle-fill text-[#d4af37] mt-0.5 flex-shrink-0"></i>
                      <span><strong>鎏金：</strong>鎏金厚重均勻，色澤金黃，有自然磨損</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-700 text-sm">
                      <i className="ri-checkbox-circle-fill text-[#d4af37] mt-0.5 flex-shrink-0"></i>
                      <span><strong>造型：</strong>面相莊嚴慈祥，身材比例符合時代特徵</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-700 text-sm">
                      <i className="ri-checkbox-circle-fill text-[#d4af37] mt-0.5 flex-shrink-0"></i>
                      <span><strong>銘文：</strong>底部或背部常有年款或銘文</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-700 text-sm">
                      <i className="ri-checkbox-circle-fill text-[#d4af37] mt-0.5 flex-shrink-0"></i>
                      <span><strong>包漿：</strong>表面有自然包漿，色澤溫潤</span>
                    </li>
                  </ul>

                  <div className="border-t border-[#f0ebe0] pt-4 mb-4">
                    <h5 className="font-bold text-[#1a3a2e] mb-2 text-sm">真偽辨別</h5>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      真品明清銅像工藝精湛，鎏金自然，包漿溫潤，有明顯的時代特徵。仿品工藝粗糙，鎏金不均，包漿做作，缺乏歷史韻味。
                    </p>
                  </div>

                  <div className="bg-[#f5f5f0] rounded-xl p-4">
                    <h5 className="font-bold text-[#1a3a2e] mb-2 text-sm flex items-center gap-2">
                      <i className="ri-star-fill text-[#d4af37]"></i>
                      收藏價值
                    </h5>
                    <p className="text-gray-700 text-sm leading-relaxed">
                      明清銅像代表了中國佛教造像藝術的巔峰，工藝精湛，藝術價值高，尤其是宮廷造辦處製作的精品，收藏價值極高。
                    </p>
                  </div>
                </div>
              </div>

              {/* 藏傳佛教造像 */}
              <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-[#f0ebe0] hover:shadow-xl transition-shadow">
                <div className="relative h-80">
                  <img
                    src="https://readdy.ai/api/search-image?query=Tibetan%20Buddhist%20statue%20with%20distinctive%20Tibetan%20artistic%20style%2C%20featuring%20elaborate%20crown%20and%20jewelry%20ornaments%2C%20gilt%20bronze%20or%20copper%20material%20with%20rich%20colors%20and%20intricate%20details%2C%20traditional%20Tibetan%20Buddhist%20iconography%20with%20multiple%20arms%20or%20symbolic%20attributes%2C%20displayed%20against%20dark%20background%20with%20warm%20lighting%20emphasizing%20sacred%20presence%20and%20cultural%20significance%2C%20museum%20quality%20religious%20artifact&width=800&height=800&seq=guide-tibetan-buddha-001&orientation=squarish"
                    alt="藏傳佛教造像鑑定指南"
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
                  <div className="absolute bottom-6 left-6">
                    <h3 className="text-3xl font-bold text-white mb-2">藏傳佛教造像</h3>
                    <p className="text-[#d4af37] text-lg">雪域聖物</p>
                  </div>
                </div>

                <div className="p-6">
                  <h4 className="text-lg font-bold text-[#1a3a2e] mb-4 flex items-center gap-2">
                    <i className="ri-eye-line text-[#d4af37]"></i>
                    鑑定要點
                  </h4>
                  <ul className="space-y-3 mb-6">
                    <li className="flex items-start gap-2 text-gray-700 text-sm">
                      <i className="ri-checkbox-circle-fill text-[#d4af37] mt-0.5 flex-shrink-0"></i>
                      <span><strong>風格：</strong>具有鮮明的藏式風格，造型獨特</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-700 text-sm">
                      <i className="ri-checkbox-circle-fill text-[#d4af37] mt-0.5 flex-shrink-0"></i>
                      <span><strong>材質：</strong>多為銅質，常鑲嵌寶石或彩繪</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-700 text-sm">
                      <i className="ri-checkbox-circle-fill text-[#d4af37] mt-0.5 flex-shrink-0"></i>
                      <span><strong>裝飾：</strong>頭冠、瓔珞等裝飾華麗精緻</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-700 text-sm">
                      <i className="ri-checkbox-circle-fill text-[#d4af37] mt-0.5 flex-shrink-0"></i>
                      <span><strong>封底：</strong>底部常有封板，內藏經文或聖物</span>
                    </li>
                    <li className="flex items-start gap-2 text-gray-700 text-sm">
                      <i className="ri-checkbox-circle-fill text-[#d4af37] mt-0.5 flex-shrink-0"></i>
                      <span><strong>銘文：</strong>底部或背部可能有藏文銘文</span>
                    </li>
                  </ul>

                  <div className="border-t border-[#f0ebe0] pt-4 mb-4">
                    <h5 className="font-bold text-[#1a3a2e] mb-2 text-sm">真偽辨別</h5>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      真品藏傳造像風格鮮明，工藝精湛，裝飾華麗，有明顯的地域特徵。仿品風格混雜，工藝粗糙，裝飾簡陋，缺乏宗教韻味。
                    </p>
                  </div>

                  <div className="bg-[#f5f5f0] rounded-xl p-4">
                    <h5 className="font-bold text-[#1a3a2e] mb-2 text-sm flex items-center gap-2">
                      <i className="ri-star-fill text-[#d4af37]"></i>
                      收藏價值
                    </h5>
                    <p className="text-gray-700 text-sm leading-relaxed">
                      藏傳佛教造像承載著深厚的宗教文化內涵，藝術風格獨特，尤其是早期精品和高僧加持過的造像，收藏價值和宗教價值兼具。
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* 底部 CTA (藏品類型指南) */}
          <div className="text-center bg-gradient-to-br from-[#1a3a2e] to-[#2d5a47] rounded-3xl p-12 relative overflow-hidden">
            <div className="absolute inset-0 opacity-10">
              <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] border border-[#d4af37] rounded-full"></div>
            </div>
            <div className="relative z-10">
              <i className="ri-search-eye-line text-[#d4af37] text-5xl mb-4 block"></i>
              <h3 className="text-3xl font-bold text-white mb-3">需要專業鑑定服務？</h3>
              <p className="text-white/70 text-lg mb-8">三十年鑑定經驗，為您的藏品提供專業評估</p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                <button
                  onClick={() => scrollToSection('free-appraisal-form')}
                  className="bg-[#d4af37] text-[#1a3a2e] px-10 py-4 rounded-full text-lg font-bold hover:bg-[#c19b2e] transition-all hover:scale-105 cursor-pointer whitespace-nowrap flex items-center gap-3"
                >
                  <i className="ri-file-list-3-line text-xl"></i>
                  立即申請免費鑑價
                </button>
                <a
                  href="tel:0916661789"
                  className="border-2 border-[#d4af37] text-white px-10 py-4 rounded-full text-lg font-semibold hover:bg-[#d4af37]/20 transition-all hover:scale-105 cursor-pointer whitespace-nowrap flex items-center gap-3"
                >
                  <i className="ri-phone-line text-xl"></i>
                  電話諮詢 0916-661789
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 常見問題 FAQ 專區 */}
      <section className="py-20 bg-[#f5f5f0]">
        <div className="max-w-7xl mx-auto px-6">
          {/* 標題 */}
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-[#1a3a2e] mb-2">常見問題</h2>
            <p className="text-gray-600">解答您的疑慮 · 讓收藏更安心</p>
          </div>

          {/* 分類標籤切換 */}
          <div className="flex justify-center mb-12">
            <div className="inline-flex flex-wrap justify-center bg-white rounded-2xl p-2 shadow-lg border border-[#f0ebe0] gap-2">
              <button
                onClick={() => {
                  setActiveFaqCategory('process');
                  setExpandedFaqIndex(null);
                }}
                className={`px-6 py-3 rounded-xl font-semibold transition-all cursor-pointer whitespace-nowrap ${
                  activeFaqCategory === 'process'
                    ? 'bg-[#d4af37] text-[#1a3a2e]'
                    : 'text-gray-600 hover:text-[#1a3a2e] hover:bg-gray-50'
                }`}
              >
                <i className="ri-file-list-3-line mr-2"></i>
                收購流程
              </button>
              <button
                onClick={() => {
                  setActiveFaqCategory('payment');
                  setExpandedFaqIndex(null);
                }}
                className={`px-6 py-3 rounded-xl font-semibold transition-all cursor-pointer whitespace-nowrap ${
                  activeFaqCategory === 'payment'
                    ? 'bg-[#d4af37] text-[#1a3a2e]'
                    : 'text-gray-600 hover:text-[#1a3a2e] hover:bg-gray-50'
                }`}
              >
                <i className="ri-money-cny-circle-line mr-2"></i>
                付款方式
              </button>
              <button
                onClick={() => {
                  setActiveFaqCategory('shipping');
                  setExpandedFaqIndex(null);
                }}
                className={`px-6 py-3 rounded-xl font-semibold transition-all cursor-pointer whitespace-nowrap ${
                  activeFaqCategory === 'shipping'
                    ? 'bg-[#d4af37] text-[#1a3a2e]'
                    : 'text-gray-600 hover:text-[#1a3a2e] hover:bg-gray-50'
                }`}
              >
                <i className="ri-truck-line mr-2"></i>
                運送安全
              </button>
              <button
                onClick={() => {
                  setActiveFaqCategory('appraisal');
                  setExpandedFaqIndex(null);
                }}
                className={`px-6 py-3 rounded-xl font-semibold transition-all cursor-pointer whitespace-nowrap ${
                  activeFaqCategory === 'appraisal'
                    ? 'bg-[#d4af37] text-[#1a3a2e]'
                    : 'text-gray-600 hover:text-[#1a3a2e] hover:bg-gray-50'
                }`}
              >
                <i className="ri-search-eye-line mr-2"></i>
                鑑定服務
              </button>
            </div>
          </div>

          {/* FAQ 手風琴列表 */}
          <div className="max-w-4xl mx-auto mb-12">
            <div className="space-y-4">
              {currentFaqList.map((faq, index) => (
                <div
                  key={index}
                  className="bg-white rounded-2xl shadow-md border border-[#f0ebe0] overflow-hidden hover:shadow-lg transition-shadow"
                >
                  {/* 問題標題 */}
                  <button
                    onClick={() => toggleFaq(index)}
                    className="w-full px-8 py-6 flex items-center justify-between text-left hover:bg-[#faf8f3] transition-colors cursor-pointer"
                  >
                    <div className="flex items-start gap-4 flex-1">
                      <div className="w-8 h-8 bg-[#d4af37]/20 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                        <span className="text-[#d4af37] font-bold text-sm">Q</span>
                      </div>
                      <h3 className="text-lg font-bold text-[#1a3a2e] leading-relaxed pr-4">
                        {faq.question}
                      </h3>
                    </div>
                    <i
                      className={`ri-arrow-down-s-line text-2xl text-[#d4af37] transition-transform flex-shrink-0 ${
                        expandedFaqIndex === index ? 'rotate-180' : ''
                      }`}
                    ></i>
                  </button>

                  {/* 答案內容 */}
                  <div
                    className={`overflow-hidden transition-all duration-300 ${
                      expandedFaqIndex === index ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
                    }`}
                  >
                    <div className="px-8 pb-6 pt-2">
                      <div className="flex items-start gap-4 bg-[#faf8f3] rounded-xl p-6 border-l-4 border-[#d4af37]">
                        <div className="w-8 h-8 bg-[#d4af37] rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                          <span className="text-white font-bold text-sm">A</span>
                        </div>
                        <p className="text-gray-700 leading-relaxed text-base">{faq.answer}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* 底部 CTA (FAQ) */}
          <div className="text-center bg-gradient-to-br from-[#1a3a2e] to-[#2d5a47] rounded-3xl p-12 relative overflow-hidden">
            <div className="absolute inset-0 opacity-10">
              <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] border border-[#d4af37] rounded-full"></div>
            </div>
            <div className="relative z-10">
              <i className="ri-customer-service-2-line text-[#d4af37] text-5xl mb-4 block"></i>
              <h3 className="text-3xl font-bold text-white mb-3">還有其他問題？</h3>
              <p className="text-white/70 text-lg mb-8">歡迎隨時聯繫我們，專業團隊為您解答</p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                <a
                  href="tel:0916661789"
                  className="bg-[#d4af37] text-[#1a3a2e] px-10 py-4 rounded-full text-lg font-bold hover:bg-[#c19b2e] transition-all hover:scale-105 cursor-pointer whitespace-nowrap flex items-center gap-3"
                >
                  <i className="ri-phone-fill text-xl"></i>
                  台灣：0916-661789
                </a>
                <a
                  href="tel:15005000353"
                  className="bg-white/10 border border-[#d4af37] text-white px-10 py-4 rounded-full text-lg font-bold hover:bg-white/20 transition-all hover:scale-105 cursor-pointer whitespace-nowrap flex items-center gap-3"
                >
                  <i className="ri-phone-fill text-xl"></i>
                  大陸：15005000353
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 客戶評價見證區 */}
      <section className="py-20 bg-gradient-to-b from-[#faf8f3] to-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-[#1a3a2e] mb-2">藏家真實評價</h2>
            <p className="text-gray-600">三十年信譽 · 千位藏家見證</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {[
              { name: '王先生', title: '資深壽山石藏家', review: '林先生的專業鑒定能力令人信服，多年來在他這裡收藏了不少精品壽山石，每一件都是真品，品質上乘。直播拍賣的形式也很透明，讓人放心競標。' },
              { name: '李女士', title: '字畫收藏愛好者', review: '光特拍賣的字畫都是名家真跡，林先生對每件作品的介紹都非常詳細專業。購買後還提供完整的鑒定證書，服務非常周到，值得信賴。' },
              { name: '張先生', title: '珠寶天珠收藏家', review: '在林先生這裡購入了幾顆天珠和翡翠，品質都非常好。他對藏品的了解非常深入，能夠講解每件藏品的來歷和特點，讓人學到很多知識。' },
              { name: '陳女士', title: '佛像藝術愛好者', review: '收藏佛像多年，林先生這裡的佛像藝術品都是精品，年代久遠，工藝精湛。他的專業態度和誠信經營讓我非常放心，已經介紹了很多朋友來。' },
              { name: '劉先生', title: '古董收藏投資者', review: '光特拍賣是我最信任的平台，林先生三十年的行業經驗和家族傳承的鑒賞能力，確保了每件藏品的真實性和價值。投資收藏首選！' },
              { name: '黃先生', title: '壽山石雕刻師', review: '作為從業者，我對壽山石的品質要求很高。林先生收購的壽山石料都是上等好料，色澤純正，質地細膩，合作多年非常愉快。' }
            ].map((testimonial, index) => (
              <div key={index} className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow">
                <div className="flex items-center mb-4">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <i key={star} className="ri-star-fill text-[#d4af37] text-xl"></i>
                  ))}
                </div>
                <h4 className="text-xl font-bold text-[#1a3a2e] mb-3">專業可靠的鑒定服務</h4>
                <p className="text-gray-600 leading-relaxed mb-6">{testimonial.review}</p>
                <div className="flex items-center">
                  <div className="w-12 h-12 bg-gradient-to-br from-[#d4af37] to-[#c19b2e] rounded-full flex items-center justify-center mr-4">
                    <i className="ri-user-line text-white text-xl"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-[#1a3a2e]">{testimonial.name}</p>
                    <p className="text-sm text-gray-500">{testimonial.title}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 聯繫方式專區 */}
      <section id="contact" className="py-20 bg-gradient-to-b from-[#f5f5f0] to-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-[#1a3a2e] mb-2">聯繫我們</h2>
            <p className="text-gray-600">多種方式聯繫 · 圖片上傳鑒定 · 快速回覆</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
            {/* 台灣收購專線 */}
            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow border border-[#f0ebe0]">
              <div className="w-14 h-14 bg-[#d4af37] rounded-full flex items-center justify-center mb-6">
                <i className="ri-phone-fill text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-[#1a3a2e] mb-3">台灣收購專線</h3>
              <a href="tel:0916661789" className="block text-2xl font-bold text-[#d4af37] hover:text-[#c19b2e] transition-colors cursor-pointer whitespace-nowrap mb-2">
                0916-661789
              </a>
              <p className="text-gray-500 text-sm">每日 9:00–21:00</p>
            </div>

            {/* 大陸收購專線 */}
            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow border border-[#f0ebe0]">
              <div className="w-14 h-14 bg-[#d4af37] rounded-full flex items-center justify-center mb-6">
                <i className="ri-phone-fill text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-[#1a3a2e] mb-3">大陸收購專線</h3>
              <a href="tel:15005000353" className="block text-2xl font-bold text-[#d4af37] hover:text-[#c19b2e] transition-colors cursor-pointer whitespace-nowrap mb-2">
                150-0500-0353
              </a>
              <p className="text-gray-500 text-sm">大陸地區直撥</p>
            </div>

            {/* Email 鑒定 */}
            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow border border-[#f0ebe0]">
              <div className="w-14 h-14 bg-[#d4af37] rounded-full flex items-center justify-center mb-6">
                <i className="ri-mail-send-fill text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-[#1a3a2e] mb-3">圖片上傳鑒定</h3>
              <a href="mailto:twgtart@gmail.com" className="block text-lg font-semibold text-[#d4af37] hover:text-[#c19b2e] transition-colors cursor-pointer break-all mb-2">
                twgtart@gmail.com
              </a>
              <p className="text-gray-500 text-sm">歡迎將藏品圖片發送至信箱，我們將盡快為您鑒定</p>
            </div>

            {/* LINE */}
            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow border border-[#f0ebe0]">
              <div className="w-14 h-14 bg-[#06C755] rounded-full flex items-center justify-center mb-6">
                <i className="ri-chat-smile-2-fill text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-[#1a3a2e] mb-3">LINE 圖片上傳</h3>
              <p className="text-2xl font-bold text-[#06C755] mb-4 whitespace-nowrap">twgtart</p>
              
              <div className="bg-gradient-to-br from-[#f5f5f0] to-white rounded-xl p-4 mb-4 border-2 border-dashed border-[#06C755]/30">
                <div className="w-full aspect-square bg-white rounded-lg flex items-center justify-center mb-2 overflow-hidden">
                  <img 
                    src="https://static.readdy.ai/image/4f3f06d226654fda02a3ba64a379f0f2/b873450daa58730c2c382d5e572253a8.jpeg"
                    alt="LINE QR Code"
                    className="w-full h-full object-contain"
                  />
                </div>
                <p className="text-center text-sm text-[#06C755] font-semibold">掃碼加好友</p>
              </div>
              
              <p className="text-gray-500 text-sm">手機可直接透過 LINE 上傳藏品圖片</p>
            </div>

            {/* YouTube */}
            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow border border-[#f0ebe0]">
              <div className="w-14 h-14 bg-red-600 rounded-full flex items-center justify-center mb-6">
                <i className="ri-youtube-fill text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-[#1a3a2e] mb-3">YouTube 頻道</h3>
              <a 
                href="https://www.youtube.com/@光特藝術拍賣" 
                target="_blank" 
                rel="noopener noreferrer"
                className="block text-lg font-bold text-red-600 hover:text-red-700 transition-colors cursor-pointer mb-2 break-all"
              >
                @光特藝術拍賣
              </a>
              <p className="text-gray-500 text-sm">訂閱頻道，觀看直播回放與精彩拍賣片段</p>
            </div>

            {/* Instagram */}
            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow border border-[#f0ebe0]">
              <div className="w-14 h-14 rounded-full flex items-center justify-center mb-6" style={{ background: 'linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888)' }}>
                <i className="ri-instagram-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-[#1a3a2e] mb-3">Instagram</h3>
              <a 
                href="https://www.instagram.com/twgtart" 
                target="_blank" 
                rel="noopener noreferrer"
                className="block text-lg font-bold hover:opacity-80 transition-opacity cursor-pointer mb-2"
                style={{ color: '#dc2743' }}
              >
                @twgtart
              </a>
              <p className="text-gray-500 text-sm">追蹤我們，掌握最新拍品與直播資訊</p>
            </div>

            {/* Facebook */}
            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow border border-[#f0ebe0]">
              <div className="w-14 h-14 bg-[#1877F2] rounded-full flex items-center justify-center mb-6">
                <i className="ri-facebook-fill text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-[#1a3a2e] mb-3">Facebook</h3>
              <a 
                href="https://www.facebook.com/p/%E5%85%89%E7%89%B9%E8%97%9D%E8%A1%93%E6%8B%8D%E8%B3%A3-61573967776391/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="block text-lg font-bold text-[#1877F2] hover:text-[#1464d8] transition-colors cursor-pointer mb-2"
              >
                光特藝術拍賣
              </a>
              <p className="text-gray-500 text-sm">按讚追蹤，獲取最新活動與拍賣公告</p>
            </div>

            {/* 大陸官網 & 台灣官網 */}
            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow border border-[#f0ebe0]">
              <div className="w-14 h-14 bg-[#1a3a2e] rounded-full flex items-center justify-center mb-6">
                <i className="ri-global-fill text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-[#1a3a2e] mb-3">官方網站</h3>
              <a href="http://app.twgtart.cn/" target="_blank" rel="nofollow noopener noreferrer" className="block text-lg font-bold text-[#d4af37] hover:text-[#c19b2e] transition-colors cursor-pointer whitespace-nowrap mb-1">
                app.twgtart.cn（大陸）
              </a>
              <a href="https://www.0977001001.com/" target="_blank" rel="nofollow noopener noreferrer" className="block text-base font-semibold text-[#d4af37] hover:text-[#c19b2e] transition-colors cursor-pointer whitespace-nowrap mb-3">
                0977001001.com（台灣）
              </a>
              <p className="text-gray-500 text-sm">線上古董藝術交易平台</p>
            </div>
          </div>

          {/* 地圖 */}
          <div className="rounded-2xl overflow-hidden shadow-xl border border-[#f0ebe0]">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3615.0!2d121.5354!3d25.0330!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3442a9a0a0a0a0a0%3A0x0!2z5Y-w5YyX5Y2A5bu65ZyL5biC5bu65ZyL5Y2A!5e0!3m2!1szh-TW!2stw!4v1700000000000!5m2!1szh-TW!2stw&q=台灣台北市建國南路一段327號"
              width="100%"
              height="400"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="光特拍賣收購地址"
            ></iframe>
          </div>
        </div>
      </section>

      {/* 藏品送鑒定表單區 */}
      <section className="py-20 bg-gradient-to-br from-[#0d1f17] to-[#1a3a2e] relative overflow-hidden">
        <div className="absolute inset-0 opacity-5">
          <div className="absolute top-20 left-20 w-96 h-96 border border-[#d4af37] rounded-full"></div>
          <div className="absolute bottom-20 right-20 w-64 h-64 border border-[#d4af37] rounded-full"></div>
        </div>

        <div className="max-w-5xl mx-auto px-6 relative z-10">
          {/* 標題 */}
          <div className="text-center mb-10">
            <h2 className="text-4xl font-bold text-white mb-2" style={{ fontFamily: "'Noto Serif SC', serif" }}>
              免費鑑價諮詢
            </h2>
            <div className="inline-flex items-center gap-2 bg-[#d4af37]/20 border border-[#d4af37]/40 rounded-full px-5 py-1.5 mt-2">
              <i className="ri-gift-line text-[#d4af37]"></i>
              <span className="text-white text-sm">完全免費 · 專業鑑定 · 24小時內回覆</span>
            </div>
          </div>

          {/* 拍攝注意事項提示卡 */}
          <div className="bg-[#d4af37]/10 border-2 border-[#d4af37]/50 rounded-2xl p-8 mb-10">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 bg-[#d4af37] rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-camera-line text-[#1a3a2e] text-xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-[#d4af37]">📸 拍攝注意事項（重要！）</h3>
            </div>
            <p className="text-white/80 mb-6 text-base leading-relaxed">
              為確保鑑定準確性，請依照以下要求拍攝藏品照片，再將圖片寄至信箱或透過 LINE / 微信傳送：
            </p>

            <div className="grid md:grid-cols-2 gap-6">
              {/* 光線要求 */}
              <div className="bg-white/5 rounded-xl p-6 border border-[#d4af37]/20">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-8 h-8 bg-yellow-500/20 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-sun-line text-yellow-400 text-lg"></i>
                  </div>
                  <h4 className="text-lg font-bold text-white">光線要求</h4>
                </div>
                <ul className="space-y-2 text-white/75 text-sm leading-relaxed">
                  <li className="flex items-start gap-2">
                    <i className="ri-checkbox-circle-fill text-[#d4af37] mt-0.5 flex-shrink-0"></i>
                    <span>選擇<strong className="text-white">自然光</strong>（靠窗位置），避免直射陽光造成反光</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-checkbox-circle-fill text-[#d4af37] mt-0.5 flex-shrink-0"></i>
                    <span>室內燈光需<strong className="text-white">均勻柔和</strong>，避免單側強光產生陰影</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-close-circle-fill text-red-400 mt-0.5 flex-shrink-0"></i>
                    <span className="text-red-300">❌ 避免：昏暗環境、強烈背光、螢光燈直射</span>
                  </li>
                </ul>
              </div>

              {/* 角度要求 */}
              <div className="bg-white/5 rounded-xl p-6 border border-[#d4af37]/20">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-8 h-8 bg-blue-500/20 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-focus-3-line text-blue-300 text-lg"></i>
                  </div>
                  <h4 className="text-lg font-bold text-white">角度要求</h4>
                </div>
                <ul className="space-y-2 text-white/75 text-sm leading-relaxed">
                  <li className="flex items-start gap-2">
                    <i className="ri-checkbox-circle-fill text-[#d4af37] mt-0.5 flex-shrink-0"></i>
                    <span>拍攝<strong className="text-white">正面、側面、底部</strong>至少3個角度</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-checkbox-circle-fill text-[#d4af37] mt-0.5 flex-shrink-0"></i>
                    <span>特殊紋理、印章、款識需<strong className="text-white">近距離特寫</strong></span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-checkbox-circle-fill text-[#d4af37] mt-0.5 flex-shrink-0"></i>
                    <span>放置於<strong className="text-white">純色背景</strong>（白紙或深色布料）上拍攝</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-checkbox-circle-fill text-[#d4af37] mt-0.5 flex-shrink-0"></i>
                    <span>可放置<strong className="text-white">尺子或硬幣</strong>作為比例參考</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* 圖片發送方式 */}
            <div className="mt-6 bg-white/5 rounded-xl p-5 border border-[#d4af37]/20">
              <h4 className="text-white font-bold mb-3 flex items-center gap-2">
                <i className="ri-send-plane-line text-[#d4af37]"></i>
                圖片發送方式（三選一）
              </h4>
              <div className="grid md:grid-cols-3 gap-4 text-sm">
                <a href="mailto:twgtart@gmail.com" className="flex items-center gap-2 text-white/80 hover:text-[#d4af37] transition-colors cursor-pointer">
                  <i className="ri-mail-line text-[#d4af37]"></i>
                  <span>twgtart@gmail.com</span>
                </a>
                <div className="flex items-center gap-2 text-white/80">
                  <i className="ri-chat-smile-2-line text-[#06C755]"></i>
                  <span>LINE：twgtart</span>
                </div>
                <a href="https://www.youtube.com/@光特藝術拍賣" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-white/80 hover:text-red-400 transition-colors cursor-pointer">
                  <i className="ri-youtube-line text-red-400"></i>
                  <span>YouTube：@光特藝術拍賣</span>
                </a>
              </div>
            </div>
          </div>

          {/* 表單 */}
          <form 
            id="free-appraisal-form" 
            data-readdy-form 
            onSubmit={handleSubmit}
            className="bg-white/5 backdrop-blur-sm border border-[#d4af37]/30 rounded-3xl p-10"
          >
            <h3 className="text-2xl font-bold text-white mb-8 flex items-center gap-3">
              <i className="ri-file-list-3-line text-[#d4af37]"></i>
              填寫鑑價申請表
            </h3>

            <div className="grid md:grid-cols-2 gap-6 mb-6">
              {/* 姓名 */}
              <div>
                <label htmlFor="name" className="block text-white text-base font-semibold mb-2">
                  姓名 <span className="text-[#d4af37]">*</span>
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                  className="w-full px-5 py-3 bg-white/10 border border-[#d4af37]/40 rounded-xl text-white placeholder-white/40 focus:outline-none focus:border-[#d4af37] focus:bg-white/15 transition-all text-sm"
                  placeholder="請輸入您的姓名"
                />
              </div>

              {/* Email */}
              <div>
                <label htmlFor="email" className="block text-white text-base font-semibold mb-2">
                  Email 信箱 <span className="text-[#d4af37]">*</span>
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  className="w-full px-5 py-3 bg-white/10 border border-[#d4af37]/40 rounded-xl text-white placeholder-white/40 focus:outline-none focus:border-[#d4af37] focus:bg-white/15 transition-all text-sm"
                  placeholder="用於接收鑑價報告"
                />
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-6 mb-6">
              {/* 聯繫方式 */}
              <div>
                <label htmlFor="contact" className="block text-white text-base font-semibold mb-2">
                  聯繫電話 / LINE / 微信 <span className="text-[#d4af37]">*</span>
                </label>
                <input
                  type="text"
                  id="contact"
                  name="contact"
                  value={formData.contact}
                  onChange={handleInputChange}
                  required
                  className="w-full px-5 py-3 bg-white/10 border border-[#d4af37]/40 rounded-xl text-white placeholder-white/40 focus:outline-none focus:border-[#d4af37] focus:bg-white/15 transition-all text-sm"
                  placeholder="電話、LINE ID 或微信 ID"
                />
              </div>

              {/* 藏品類型 */}
              <div>
                <label htmlFor="itemType" className="block text-white text-base font-semibold mb-2">
                  藏品類型 <span className="text-[#d4af37]">*</span>
                </label>
                <select
                  id="itemType"
                  name="itemType"
                  value={formData.itemType}
                  onChange={handleInputChange}
                  required
                  className="w-full px-5 py-3 bg-[#1a3a2e] border border-[#d4af37]/40 rounded-xl text-white focus:outline-none focus:border-[#d4af37] transition-all cursor-pointer text-sm"
                >
                  <option value="">請選擇藏品類型</option>
                  <option value="壽山石（田黃）">壽山石（田黃）</option>
                  <option value="壽山石（芙蓉石）">壽山石（芙蓉石）</option>
                  <option value="壽山石（雞血石）">壽山石（雞血石）</option>
                  <option value="壽山石（其他）">壽山石（其他）</option>
                  <option value="字畫">字畫</option>
                  <option value="翡翠珠寶">翡翠珠寶</option>
                  <option value="西藏天珠">西藏天珠</option>
                  <option value="佛像">佛像</option>
                  <option value="其他古董">其他古董</option>
                </select>
              </div>
            </div>

            {/* 藏品描述 */}
            <div className="mb-6">
              <label htmlFor="description" className="block text-white text-base font-semibold mb-2">
                藏品描述 <span className="text-[#d4af37]">*</span>
                <span className="text-sm text-white/50 ml-2">（尺寸、年代、來源、特徵等，限500字）</span>
              </label>
              <textarea
                id="description"
                name="description"
                value={formData.description}
                onChange={handleInputChange}
                required
                maxLength={500}
                rows={5}
                className="w-full px-5 py-3 bg-white/10 border border-[#d4af37]/40 rounded-xl text-white placeholder-white/40 focus:outline-none focus:border-[#d4af37] focus:bg-white/15 transition-all resize-none text-sm"
                placeholder="例如：壽山石印章一枚，橙紅色，約5×5×8cm，底部有篆刻印文，家傳藏品，年代不詳，請協助鑑定..."
              ></textarea>
              <div className="flex justify-between mt-1">
                <span className="text-white/50 text-xs">描述越詳細，鑑定越準確</span>
                <span className={`text-xs ${formData.description.length > 450 ? 'text-red-400' : 'text-white/50'}`}>
                  {formData.description.length}/500
                </span>
              </div>
            </div>

            {/* 拍攝確認勾選 */}
            <div className="mb-8 bg-[#d4af37]/10 border border-[#d4af37]/30 rounded-xl p-5">
              <label className="flex items-start gap-3 cursor-pointer">
                <input
                  type="checkbox"
                  name="photoConfirm"
                  checked={formData.photoConfirm}
                  onChange={handleInputChange}
                  className="mt-1 w-5 h-5 accent-[#d4af37] cursor-pointer flex-shrink-0"
                />
                <span className="text-white/90 text-sm leading-relaxed">
                  我已閱讀上方<strong className="text-[#d4af37]">拍攝注意事項</strong>，將依照光線與角度要求拍攝藏品照片，並透過 Email / LINE / 微信 傳送圖片，以便獲得更準確的免費鑑價結果。
                </span>
              </label>
            </div>

            {/* 免費鑑價說明 */}
            <div className="mb-8 flex flex-wrap gap-4">
              {[
                { icon: 'ri-gift-line', text: '完全免費，無需付費' },
                { icon: 'ri-time-line', text: '24小時內專業回覆' },
                { icon: 'ri-shield-check-line', text: '三十年鑑定經驗保證' },
                { icon: 'ri-lock-line', text: '資料保密，安全可靠' }
              ].map((item, i) => (
                <div key={i} className="flex items-center gap-2 bg-white/5 rounded-full px-4 py-1 border border-white/10">
                  <i className={`${item.icon} text-[#d4af37]`}></i>
                  <span className="text-white/80 text-sm whitespace-nowrap">{item.text}</span>
                </div>
              ))}
            </div>

            {/* 提交按鈕 */}
            <button
              type="submit"
              disabled={formStatus === 'submitting'}
              className="w-full bg-[#d4af37] text-[#1a3a2e] px-8 py-5 rounded-xl text-xl font-bold hover:bg-[#c19b2e] transition-all hover:scale-[1.02] disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer whitespace-nowrap flex items-center justify-center gap-3"
            >
              {formStatus === 'submitting' ? (
                <>
                  <i className="ri-loader-4-line animate-spin text-2xl"></i>
                  提交中，請稍候...
                </>
              ) : (
                <>
                  <i className="ri-mail-send-fill text-2xl"></i>
                  立即申請免費鑑價
                </>
              )}
            </button>

            {/* 成功提示 */}
            {formStatus === 'success' && (
              <div className="mt-6 bg-green-500/20 border border-green-500/50 rounded-xl p-5 flex items-start gap-3">
                <i className="ri-checkbox-circle-fill text-green-400 text-2xl flex-shrink-0 mt-0.5"></i>
                <div>
                  <p className="text-green-400 font-bold text-lg">申請提交成功！🎉</p>
                  <p className="text-white/80 text-sm mt-1">我們已收到您的免費鑑價申請，請記得將藏品照片寄至 <strong className="text-[#d4af37]">twgtart@gmail.com</strong> 或透過 LINE（twgtart）傳送，我們將在24小時內回覆您。</p>
                </div>
              </div>
            )}

            {/* 錯誤提示 */}
            {formStatus === 'error' && (
              <div className="mt-6 bg-red-500/20 border border-red-500/50 rounded-xl p-4 flex items-center gap-3">
                <i className="ri-error-warning-fill text-red-400 text-2xl"></i>
                <div>
                  <p className="text-red-400 font-semibold">提交失敗，請稍後再試</p>
                  <p className="text-white/70 text-sm">或直接撥打 <a href="tel:0916661789" className="text-[#d4af37] font-bold">0916-661789</a> 聯繫我們</p>
                </div>
              </div>
            )}
          </form>

          {/* 底部提示 */}
          <div className="mt-8 text-center">
            <p className="text-white/60 text-sm">
              如需緊急鑑定，請直接撥打收購專線：
              <a href="tel:0916661789" className="text-[#d4af37] hover:text-[#c19b2e] font-semibold ml-2 cursor-pointer whitespace-nowrap">
                0916-661789（台灣）
              </a>
              <span className="text-white/40 mx-2">|</span>
              <a href="tel:15005000353" className="text-[#d4af37] hover:text-[#c19b2e] font-semibold cursor-pointer whitespace-nowrap">
                15005000353（大陸）
              </a>
            </p>
          </div>
        </div>
      </section>

      {/* CTA 行動召喚區 */}
      <section className="relative h-[500px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src="https://readdy.ai/api/search-image?query=Luxurious%20Chinese%20antique%20auction%20house%20showroom%20interior%2C%20featuring%20elegant%20display%20cases%20filled%20with%20precious%20Shoushan%20stones%2C%20jade%20artifacts%2C%20Buddhist%20statues%20and%20calligraphy%20scrolls%2C%20warm%20professional%20lighting%20creating%20sophisticated%20atmosphere%2C%20high-end%20gallery%20space%20with%20traditional%20Chinese%20architectural%20elements%20and%20modern%20design%2C%20inviting%20and%20prestigious%20ambiance&width=1920&height=1080&seq=cta-background-001&orientation=landscape"
            alt="拍賣展廳"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/50"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 w-full">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div>
              <h2 className="text-5xl font-bold text-white mb-3 leading-tight">立即開啟您的收藏之旅</h2>
              <p className="text-lg text-white/80">專業鑒定 · 安全交易 · 讓每件藏品找到懂它的人</p>
            </div>
            <div className="mt-8 md:mt-0">
              <div className="flex flex-wrap gap-4 justify-end">
                <a href="tel:0916661789" className="inline-flex items-center bg-white text-[#1a3a2e] px-8 py-4 rounded-full text-lg font-semibold hover:bg-gray-100 transition-all hover:scale-105 cursor-pointer whitespace-nowrap">
                  <span className="mr-3">台灣 0916-661789</span>
                  <div className="w-10 h-10 bg-[#1a3a2e] rounded-full flex items-center justify-center">
                    <i className="ri-phone-line text-white"></i>
                  </div>
                </a>
                <a href="tel:15005000353" className="inline-flex items-center bg-[#d4af37] text-[#1a3a2e] px-8 py-4 rounded-full text-lg font-semibold hover:bg-[#c19b2e] transition-all hover:scale-105 cursor-pointer whitespace-nowrap">
                  <span className="mr-3">大陸 15005000353</span>
                  <div className="w-10 h-10 bg-[#1a3a2e] rounded-full flex items-center justify-center">
                    <i className="ri-phone-line text-white"></i>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#1a3a2e] text-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-5">
          <svg className="w-full h-full" viewBox="0 0 1200 400">
            <path d="M0,200 Q300,100 600,200 T1200,200" fill="none" stroke="currentColor" strokeWidth="2"/>
            <path d="M0,250 Q300,150 600,250 T1200,250" fill="none" stroke="currentColor" strokeWidth="2"/>
          </svg>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 py-16">
          <div className="grid md:grid-cols-5 gap-12 mb-12">
            <div className="md:col-span-2">
              <div className="flex items-center space-x-3 mb-6">
                <img 
                  src="https://static.readdy.ai/image/4f3f06d226654fda02a3ba64a379f0f2/b873450daa58730c2c382d5e572253a8.jpeg" 
                  alt="光特" 
                  className="h-12 w-12 object-contain rounded-full"
                />
                <span className="text-3xl font-bold">光特</span>
              </div>
              <p className="text-3xl font-bold mb-8 leading-relaxed">傳承中華<br/>收藏文化</p>
              <p className="text-white/70 mb-4">專注壽山石、字畫、珠寶天珠、佛像藝術</p>
              <p className="text-white/70">三十年專業鑒賞經驗 · 誠信為本</p>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4 whitespace-nowrap">收藏專區</h4>
              <ul className="space-y-3">
                <li><button onClick={() => scrollToSection('shoushan')} className="text-white/70 hover:text-[#d4af37] transition-colors cursor-pointer whitespace-nowrap">壽山石收購</button></li>
                <li><button onClick={() => scrollToSection('calligraphy')} className="text-white/70 hover:text-[#d4af37] transition-colors cursor-pointer whitespace-nowrap">字畫鑒賞</button></li>
                <li><button onClick={() => scrollToSection('jewelry')} className="text-white/70 hover:text-[#d4af37] transition-colors cursor-pointer whitespace-nowrap">珠寶天珠</button></li>
                <li><button onClick={() => scrollToSection('buddha')} className="text-white/70 hover:text-[#d4af37] transition-colors cursor-pointer whitespace-nowrap">佛像藝術</button></li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4 whitespace-nowrap">服務項目</h4>
              <ul className="space-y-3">
                <li><a href="tel:0916661789" className="text-white/70 hover:text-[#d4af37] transition-colors cursor-pointer whitespace-nowrap">直播拍賣</a></li>
                <li><a href="tel:0916661789" className="text-white/70 hover:text-[#d4af37] transition-colors cursor-pointer whitespace-nowrap">藏品鑑定</a></li>
                <li><a href="tel:0916661789" className="text-white/70 hover:text-[#d4af37] transition-colors cursor-pointer whitespace-nowrap">委託拍賣</a></li>
                <li><a href="tel:0916661789" className="text-white/70 hover:text-[#d4af37] transition-colors cursor-pointer whitespace-nowrap">收藏諮詢</a></li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4 whitespace-nowrap">聯繫資訊</h4>
              <ul className="space-y-3">
                <li className="flex items-center text-white/70">
                  <i className="ri-phone-line mr-2"></i>
                  <a href="tel:0916661789" className="hover:text-[#d4af37] transition-colors cursor-pointer whitespace-nowrap">0916-661789（台灣）</a>
                </li>
                <li className="flex items-center text-white/70">
                  <i className="ri-phone-line mr-2"></i>
                  <a href="tel:15005000353" className="hover:text-[#d4af37] transition-colors cursor-pointer whitespace-nowrap">15005000353（大陸）</a>
                </li>
                <li className="flex items-center text-white/70">
                  <i className="ri-mail-line mr-2"></i>
                  <a href="mailto:twgtart@gmail.com" className="hover:text-[#d4af37] transition-colors cursor-pointer break-all">twgtart@gmail.com</a>
                </li>
                <li className="flex items-start text-white/70">
                  <i className="ri-map-pin-line mr-2 mt-1 flex-shrink-0"></i>
                  <span>台灣台北市建國南路一段327號</span>
                </li>
                <li className="flex items-center text-white/70">
                  <i className="ri-chat-smile-2-line mr-2"></i>
                  <span className="whitespace-nowrap">LINE：twgtart</span>
                </li>
                <li className="flex items-center text-white/70">
                  <i className="ri-youtube-line mr-2"></i>
                  <a href="https://www.youtube.com/@光特藝術拍賣" target="_blank" rel="noopener noreferrer" className="hover:text-[#d4af37] transition-colors cursor-pointer whitespace-nowrap">YouTube：@光特藝術拍賣</a>
                </li>
                <li className="flex items-center text-white/70">
                  <i className="ri-global-line mr-2"></i>
                  <a href="http://app.twgtart.cn/" target="_blank" rel="nofollow noopener noreferrer" className="hover:text-[#d4af37] transition-colors cursor-pointer whitespace-nowrap">app.twgtart.cn（大陸）</a>
                </li>
                <li className="flex items-center text-white/70">
                  <i className="ri-time-line mr-2"></i>
                  <span className="whitespace-nowrap">每日 9:00-21:00</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-white/20 pt-8 flex flex-col md:flex-row items-center justify-between">
            <p className="text-white/60 text-sm mb-4 md:mb-0">© 2025 光特藝術拍賣 版權所有</p>
            
            <div className="flex items-center space-x-6 mb-4 md:mb-0">
              <a href="https://www.instagram.com/twgtart" target="_blank" rel="noopener noreferrer" className="w-10 h-10 border border-white/30 rounded-lg flex items-center justify-center hover:border-pink-400 hover:text-pink-400 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="https://www.facebook.com/p/%E5%85%89%E7%89%B9%E8%97%9D%E8%A1%93%E6%8B%8D%E8%B3%A3-61573967776391/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 border border-white/30 rounded-lg flex items-center justify-center hover:border-[#1877F2] hover:text-[#1877F2] transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="https://www.youtube.com/@光特藝術拍賣" target="_blank" rel="noopener noreferrer" className="w-10 h-10 border border-white/30 rounded-lg flex items-center justify-center hover:border-red-500 hover:text-red-500 transition-colors cursor-pointer">
                <i className="ri-youtube-line text-xl"></i>
              </a>
              <a href="http://app.twgtart.cn/" target="_blank" rel="nofollow noopener noreferrer" className="w-10 h-10 border border-white/30 rounded-lg flex items-center justify-center hover:border-[#d4af37] hover:text-[#d4af37] transition-colors cursor-pointer">
                <i className="ri-global-line text-xl"></i>
              </a>
              <a href="mailto:twgtart@gmail.com" className="w-10 h-10 border border-white/30 rounded-lg flex items-center justify-center hover:border-[#d4af37] hover:text-[#d4af37] transition-colors cursor-pointer">
                <i className="ri-mail-line text-xl"></i>
              </a>
              <a href="tel:0916661789" className="w-10 h-10 border border-white/30 rounded-lg flex items-center justify-center hover:border-[#d4af37] hover:text-[#d4af37] transition-colors cursor-pointer">
                <i className="ri-phone-line text-xl"></i>
              </a>
            </div>

            <p className="text-white/60 text-sm whitespace-nowrap">隱私政策 | 服務條款</p>
          </div>

          {/* 公司登記資訊 */}
          <div className="border-t border-white/10 pt-6 mt-2">
            <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-white/40 text-xs">
              <span className="flex items-center gap-1 whitespace-nowrap">
                <i className="ri-government-line"></i>
                統一編號：60005399
              </span>
              <span className="hidden sm:inline text-white/20">|</span>
              <span className="flex items-center gap-1 whitespace-nowrap">
                <i className="ri-store-2-line"></i>
                台灣光特企業社
              </span>
              <span className="hidden sm:inline text-white/20">|</span>
              <span className="flex items-center gap-1 whitespace-nowrap">
                <i className="ri-user-line"></i>
                負責人：林偉昌
              </span>
              <span className="hidden sm:inline text-white/20">|</span>
              <span className="flex items-center gap-1 whitespace-nowrap">
                <i className="ri-map-pin-line"></i>
                新北市新店區安興路127之3號
              </span>
              <span className="hidden sm:inline text-white/20">|</span>
              <span className="flex items-center gap-1 whitespace-nowrap">
                <i className="ri-building-line"></i>
                登記機關：新北市政府經濟發展局
              </span>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}